// import React, { useState } from "react";

// export default function MerchantLoyaltyRules() {

//   const [visitNumber, setVisitNumber] = useState("");
//   const [reward, setReward] = useState("");
//   const [googleLink, setGoogleLink] = useState("");

//   const [rules, setRules] = useState([
//     {
//       id: 1,
//       visit: 3,
//       reward: "Free Cold Coffee",
//     },
//     {
//       id: 2,
//       visit: 5,
//       reward: "20% OFF Coupon",
//     },
//   ]);

//   const [editingId, setEditingId] = useState(null);

//   const addRule = () => {

//     if (!visitNumber || !reward) return;

//     if (editingId) {

//       setRules(
//         rules.map((item) =>
//           item.id === editingId
//             ? {
//                 ...item,
//                 visit: visitNumber,
//                 reward: reward,
//               }
//             : item
//         )
//       );

//       setEditingId(null);

//     } else {

//       const newRule = {
//         id: Date.now(),
//         visit: visitNumber,
//         reward: reward,
//       };

//       setRules([...rules, newRule]);

//     }

//     setVisitNumber("");
//     setReward("");

//   };

//   const editRule = (item) => {

//     setVisitNumber(item.visit);
//     setReward(item.reward);
//     setEditingId(item.id);

//   };

//   const deleteRule = (id) => {

//     setRules(
//       rules.filter((item) => item.id !== id)
//     );

//   };

//   const saveGoogleLink = () => {

//     alert("Google Review Link Saved Successfully");

//   };

//   return (
//     <>
//       <style>{`

//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f5f7fb;
//         }

//         .merchant-page{
//           min-height:100vh;
//           padding:35px;
//           background:
//           linear-gradient(135deg,#fff7ed,#fff,#eef4ff);
//         }

//         /* HEADER */

//         .top-header{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           flex-wrap:wrap;
//           gap:20px;
//           margin-bottom:35px;
//         }

//         .top-header h1{
//           font-size:42px;
//           font-weight:800;
//           color:#111827;
//           margin-bottom:8px;
//         }

//         .top-header p{
//           color:#6b7280;
//           font-size:16px;
//         }

//         .merchant-logo{
//           width:75px;
//           height:75px;
//           border-radius:24px;
//           background:
//           linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//           box-shadow:0 15px 30px rgba(255,94,98,0.3);
//         }

//         /* MAIN GRID */

//         .main-grid{
//           display:grid;
//           grid-template-columns:420px 1fr;
//           gap:30px;
//         }

//         /* CARD */

//         .card{
//           background:white;
//           border-radius:35px;
//           padding:35px;
//           box-shadow:0 15px 45px rgba(0,0,0,0.06);
//         }

//         .card h2{
//           font-size:30px;
//           margin-bottom:12px;
//           color:#111827;
//         }

//         .card p{
//           color:#6b7280;
//           line-height:1.7;
//           margin-bottom:30px;
//         }

//         /* INPUTS */

//         .input-group{
//           margin-bottom:22px;
//         }

//         .input-group label{
//           display:block;
//           margin-bottom:12px;
//           font-size:15px;
//           font-weight:700;
//           color:#374151;
//         }

//         .input-group input{
//           width:100%;
//           height:65px;
//           border:none;
//           background:#f9fafb;
//           border-radius:18px;
//           padding:0 20px;
//           font-size:16px;
//           outline:none;
//           transition:0.3s;
//         }

//         .input-group input:focus{
//           background:white;
//           box-shadow:0 0 0 4px rgba(255,140,66,0.15);
//         }

//         /* BUTTON */

//         .save-btn{
//           width:100%;
//           height:65px;
//           border:none;
//           border-radius:18px;
//           background:
//           linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .save-btn:hover{
//           transform:translateY(-3px);
//           box-shadow:0 15px 30px rgba(255,94,98,0.3);
//         }

//         /* TABLE */

//         .table-container{
//           overflow:auto;
//         }

//         table{
//           width:100%;
//           border-collapse:collapse;
//           min-width:700px;
//         }

//         th{
//           background:#fff7ed;
//           color:#111827;
//           padding:18px;
//           text-align:left;
//           font-size:15px;
//         }

//         td{
//           padding:20px 18px;
//           border-bottom:1px solid #eee;
//           color:#4b5563;
//           font-size:15px;
//         }

//         tr:hover{
//           background:#fafafa;
//         }

//         .badge{
//           display:inline-block;
//           padding:10px 18px;
//           border-radius:30px;
//           background:#ecfdf5;
//           color:#059669;
//           font-size:13px;
//           font-weight:700;
//         }

//         .actions{
//           display:flex;
//           gap:12px;
//         }

//         .edit-btn{
//           border:none;
//           padding:10px 18px;
//           border-radius:14px;
//           background:#fff7ed;
//           color:#ff6b35;
//           font-weight:700;
//           cursor:pointer;
//         }

//         .delete-btn{
//           border:none;
//           padding:10px 18px;
//           border-radius:14px;
//           background:#fee2e2;
//           color:#dc2626;
//           font-weight:700;
//           cursor:pointer;
//         }

//         /* GOOGLE BOX */

//         .google-box{
//           margin-top:35px;
//           background:
//           linear-gradient(135deg,#111827,#1f2937);
//           border-radius:30px;
//           padding:35px;
//           color:white;
//         }

//         .google-box h2{
//           color:white;
//           margin-bottom:15px;
//         }

//         .google-box p{
//           color:#d1d5db;
//           margin-bottom:25px;
//         }

//         .google-input{
//           display:flex;
//           gap:15px;
//           flex-wrap:wrap;
//         }

//         .google-input input{
//           flex:1;
//           min-width:220px;
//           height:65px;
//           border:none;
//           border-radius:18px;
//           padding:0 20px;
//           font-size:16px;
//           outline:none;
//         }

//         .google-save{
//           padding:0 30px;
//           border:none;
//           border-radius:18px;
//           background:#ff8c42;
//           color:white;
//           font-size:16px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .google-save:hover{
//           background:#ff6b35;
//         }

//         @media(max-width:1000px){

//           .main-grid{
//             grid-template-columns:1fr;
//           }

//         }

//         @media(max-width:768px){

//           .merchant-page{
//             padding:20px;
//           }

//           .top-header h1{
//             font-size:30px;
//           }

//           .card{
//             padding:25px;
//           }

//           .card h2{
//             font-size:25px;
//           }

//         }

//       `}</style>

//       <div className="merchant-page">

//         {/* HEADER */}

//         <div className="top-header">

//           <div>

//             <h1>
//               Merchant Loyalty Rules
//             </h1>

//             <p>
//               Create visit campaigns, rewards & customer engagement offers
//             </p>

//           </div>

//           <div className="merchant-logo">
//             🍽️
//           </div>

//         </div>

//         {/* GRID */}

//         <div className="main-grid">

//           {/* LEFT FORM */}

//           <div className="card">

//             <h2>
//               Dynamic Rule Creator
//             </h2>

//             <p>
//               Configure custom loyalty rewards based on customer visits.
//             </p>

//             <div className="input-group">

//               <label>
//                 Visit Number
//               </label>

//               <input
//                 type="number"
//                 placeholder="e.g. 4"
//                 value={visitNumber}
//                 onChange={(e) =>
//                   setVisitNumber(e.target.value)
//                 }
//               />

//             </div>

//             <div className="input-group">

//               <label>
//                 Reward Details
//               </label>

//               <input
//                 type="text"
//                 placeholder="e.g. 20% OFF"
//                 value={reward}
//                 onChange={(e) =>
//                   setReward(e.target.value)
//                 }
//               />

//             </div>

//             <button
//               className="save-btn"
//               onClick={addRule}
//             >
//               {editingId
//                 ? "Update Rule"
//                 : "Add Rule"}
//             </button>

//           </div>

//           {/* TABLE */}

//           <div className="card">

//             <h2>
//               Active Campaign Management
//             </h2>

//             <p>
//               Manage all active loyalty campaigns and reward configurations.
//             </p>

//             <div className="table-container">

//               <table>

//                 <thead>

//                   <tr>

//                     <th>Sl No</th>
//                     <th>Visit Number</th>
//                     <th>Reward Details</th>
//                     <th>Status</th>
//                     <th>Actions</th>

//                   </tr>

//                 </thead>

//                 <tbody>

//                   {rules.map((item, index) => (

//                     <tr key={item.id}>

//                       <td>
//                         {index + 1}
//                       </td>

//                       <td>
//                         Visit {item.visit}
//                       </td>

//                       <td>
//                         {item.reward}
//                       </td>

//                       <td>
//                         <span className="badge">
//                           Active
//                         </span>
//                       </td>

//                       <td>

//                         <div className="actions">

//                           <button
//                             className="edit-btn"
//                             onClick={() =>
//                               editRule(item)
//                             }
//                           >
//                             Edit
//                           </button>

//                           <button
//                             className="delete-btn"
//                             onClick={() =>
//                               deleteRule(item.id)
//                             }
//                           >
//                             Delete
//                           </button>

//                         </div>

//                       </td>

//                     </tr>

//                   ))}

//                 </tbody>

//               </table>

//             </div>

//           </div>

//         </div>

//         {/* GOOGLE LINK */}

//         <div className="google-box">

//           <h2>
//             Google Review Link Integrator
//           </h2>

//           <p>
//             Paste your original Google Business Review URL here.
//           </p>

//           <div className="google-input">

//             <input
//               type="text"
//               placeholder="Paste Google Review URL..."
//               value={googleLink}
//               onChange={(e) =>
//                 setGoogleLink(e.target.value)
//               }
//             />

//             <button
//               className="google-save"
//               onClick={saveGoogleLink}
//             >
//               Save Link
//             </button>

//           </div>

//         </div>

//       </div>
//     </>
//   );
// }



// import React, { useState, useEffect } from "react";

// export default function MerchantLoyaltyRules() {
//   const [visitNumber, setVisitNumber] = useState("");
//   const [reward, setReward] = useState("");
//   const [googleLink, setGoogleLink] = useState("");
//   const [rules, setRules] = useState([]);
//   const [editingId, setEditingId] = useState(null);

//   const MERCHANT_ID = "CMV9A117EAC"; // Global Merchant ID variable

//   // 1. Fetch Rules from API on Component Mount
//   const fetchRules = () => {
//     const formdata = new FormData();
//     formdata.append("user_id", MERCHANT_ID);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`https://countmyvisit.com/Apis/getmarchantdashdetails.php?user_id=${MERCHANT_ID}`, requestOptions)
//       .then((response) => response.json()) // Agar backend json bhej raha hai to text() ki jagah json() use karein
//       .then((result) => {
//         // Agar backend se seedhe array mil raha hai:
//         if (Array.isArray(result)) {
//           setRules(result);
//         } else if (result.data) { 
//           // Agar kisi objects ke andar array hai (Adjust according to actual API response)
//           setRules(result.data);
//         }
//       })
//       .catch((error) => console.error("Error fetching rules:", error));
//   };

//   useEffect(() => {
//     fetchRules();
//   }, []);

//   // 2. Add or Update Rule API Call
//   const addRule = () => {
//     if (!visitNumber || !reward) return;

//     if (editingId) {
//       // Edit / Update API Call
//       const formdata = new FormData();
//       formdata.append("id", editingId);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       // Agar 'total_visits' field bhi backend accept karta ho update me:
//       formdata.append("total_visits", visitNumber); 

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       };

//       // Query parameter ki space fix ki hai (?pass_id =1 to ?pass_id=1)
//       fetch(`https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`, requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           console.log("Update Success:", result);
//           setEditingId(null);
//           fetchRules(); // UI refresh karne ke liye fresh data pull karein
//         })
//         .catch((error) => console.error("Error updating rule:", error));

//     } else {
//       // Add New Rule API Call
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       formdata.append("total_visits", visitNumber);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       };

//       fetch("https://countmyvisit.com/Apis/add_loyalty_pass.php", requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           console.log("Add Success:", result);
//           fetchRules(); // List refresh karein
//         })
//         .catch((error) => console.error("Error adding rule:", error));
//     }

//     setVisitNumber("");
//     setReward("");
//   };

//   // Prepare fields for editing
//   const editRule = (item) => {
//     // Note: Agar aapki API se field names alag aa rahe hain (like item.total_visits ya item.title), to use yahan map karein.
//     setVisitNumber(item.visit || item.total_visits || "");
//     setReward(item.reward || "");
//     setEditingId(item.id);
//   };

//   // 3. Delete Rule API Call
//   const deleteRule = (id) => {
//     const formdata = new FormData();
//     formdata.append("id", id); // Assuming backend expects ID to delete

//     const requestOptions = {
//       method: "POST",
//       body: formdata, // Added missing body data here
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/delete_loyalty_pass.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         console.log("Delete Success:", result);
//         fetchRules(); // List refresh karein after delete
//       })
//       .catch((error) => console.error("Error deleting rule:", error));
//   };

//   const saveGoogleLink = () => {
//     alert("Google Review Link Saved Successfully");
//   };

//   return (
//     <>
//       <style>{`
//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }
//         body{
//           background:#f5f7fb;
//         }
//         .merchant-page{
//           min-height:100vh;
//           padding:35px;
//           background: linear-gradient(135deg,#fff7ed,#fff,#eef4ff);
//         }
//         .top-header{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           flex-wrap:wrap;
//           gap:20px;
//           margin-bottom:35px;
//         }
//         .top-header h1{
//           font-size:42px;
//           font-weight:800;
//           color:#111827;
//           margin-bottom:8px;
//         }
//         .top-header p{
//           color:#6b7280;
//           font-size:16px;
//         }
//         .merchant-logo{
//           width:75px;
//           height:75px;
//           border-radius:24px;
//           background: linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//           box-shadow:0 15px 30px rgba(255,94,98,0.3);
//         }
//         .main-grid{
//           display:grid;
//           grid-template-columns:420px 1fr;
//           gap:30px;
//         }
//         .card{
//           background:white;
//           border-radius:35px;
//           padding:35px;
//           box-shadow:0 15px 45px rgba(0,0,0,0.06);
//         }
//         .card h2{
//           font-size:30px;
//           margin-bottom:12px;
//           color:#111827;
//         }
//         .card p{
//           color:#6b7280;
//           line-height:1.7;
//           margin-bottom:30px;
//         }
//         .input-group{
//           margin-bottom:22px;
//         }
//         .input-group label{
//           display:block;
//           margin-bottom:12px;
//           font-size:15px;
//           font-weight:700;
//           color:#374151;
//         }
//         .input-group input{
//           width:100%;
//           height:65px;
//           border:none;
//           background:#f9fafb;
//           border-radius:18px;
//           padding:0 20px;
//           font-size:16px;
//           outline:none;
//           transition:0.3s;
//         }
//         .input-group input:focus{
//           background:white;
//           box-shadow:0 0 0 4px rgba(255,140,66,0.15);
//         }
//         .save-btn{
//           width:100%;
//           height:65px;
//           border:none;
//           border-radius:18px;
//           background: linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }
//         .save-btn:hover{
//           transform:translateY(-3px);
//           box-shadow:0 15px 30px rgba(255,94,98,0.3);
//         }
//         .table-container{
//           overflow:auto;
//         }
//         table{
//           width:100%;
//           border-collapse:collapse;
//           min-width:700px;
//         }
//         th{
//           background:#fff7ed;
//           color:#111827;
//           padding:18px;
//           text-align:left;
//           font-size:15px;
//         }
//         td{
//           padding:20px 18px;
//           border-bottom:1px solid #eee;
//           color:#4b5563;
//           font-size:15px;
//         }
//         tr:hover{
//           background:#fafafa;
//         }
//         .badge{
//           display:inline-block;
//           padding:10px 18px;
//           border-radius:30px;
//           background:#ecfdf5;
//           color:#059669;
//           font-size:13px;
//           font-weight:700;
//         }
//         .actions{
//           display:flex;
//           gap:12px;
//         }
//         .edit-btn{
//           border:none;
//           padding:10px 18px;
//           border-radius:14px;
//           background:#fff7ed;
//           color:#ff6b35;
//           font-weight:700;
//           cursor:pointer;
//         }
//         .delete-btn{
//           border:none;
//           padding:10px 18px;
//           border-radius:14px;
//           background:#fee2e2;
//           color:#dc2626;
//           font-weight:700;
//           cursor:pointer;
//         }
//         .google-box{
//           margin-top:35px;
//           background: linear-gradient(135deg,#111827,#1f2937);
//           border-radius:30px;
//           padding:35px;
//           color:white;
//         }
//         .google-box h2{
//           color:white;
//           margin-bottom:15px;
//         }
//         .google-box p{
//           color:#d1d5db;
//           margin-bottom:25px;
//         }
//         .google-input{
//           display:flex;
//           gap:15px;
//           flex-wrap:wrap;
//         }
//         .google-input input{
//           flex:1;
//           min-width:220px;
//           height:65px;
//           border:none;
//           border-radius:18px;
//           padding:0 20px;
//           font-size:16px;
//           outline:none;
//         }
//         .google-save{
//           padding:0 30px;
//           border:none;
//           border-radius:18px;
//           background:#ff8c42;
//           color:white;
//           font-size:16px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }
//         .google-save:hover{
//           background:#ff6b35;
//         }
//         @media(max-width:1000px){
//           .main-grid{
//             grid-template-columns:1fr;
//           }
//         }
//         @media(max-width:768px){
//           .merchant-page{
//             padding:20px;
//           }
//           .top-header h1{
//             font-size:30px;
//           }
//           .card{
//             padding:25px;
//           }
//           .card h2{
//             font-size:25px;
//           }
//         }
//       `}</style>

//       <div className="merchant-page">
//         {/* HEADER */}
//         <div className="top-header">
//           <div>
//             <h1>Merchant Loyalty Rules</h1>
//             <p>Create visit campaigns, rewards & customer engagement offers</p>
//           </div>
//           <div className="merchant-logo">🍽️</div>
//         </div>

//         {/* GRID */}
//         <div className="main-grid">
//           {/* LEFT FORM */}
//           <div className="card">
//             <h2>Dynamic Rule Creator</h2>
//             <p>Configure custom loyalty rewards based on customer visits.</p>

//             <div className="input-group">
//               <label>Visit Number</label>
//               <input
//                 type="number"
//                 placeholder="e.g. 4"
//                 value={visitNumber}
//                 onChange={(e) => setVisitNumber(e.target.value)}
//               />
//             </div>

//             <div className="input-group">
//               <label>Reward Details</label>
//               <input
//                 type="text"
//                 placeholder="e.g. 20% OFF"
//                 value={reward}
//                 onChange={(e) => setReward(e.target.value)}
//               />
//             </div>

//             <button className="save-btn" onClick={addRule}>
//               {editingId ? "Update Rule" : "Add Rule"}
//             </button>
//           </div>

//           {/* TABLE */}
//           <div className="card">
//             <h2>Active Campaign Management</h2>
//             <p>Manage all active loyalty campaigns and reward configurations.</p>

//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Sl No</th>
//                     <th>Visit Number</th>
//                     <th>Reward Details</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rules.map((item, index) => (
//                     <tr key={item.id || index}>
//                       <td>{index + 1}</td>
//                       <td>
//                         {/* API keys mapping ka handle kiya h fallback ke sath */}
//                         Visit {item.visit || item.total_visits || item.title}
//                       </td>
//                       <td>{item.reward}</td>
//                       <td>
//                         <span className="badge">Active</span>
//                       </td>
//                       <td>
//                         <div className="actions">
//                           <button
//                             className="edit-btn"
//                             onClick={() => editRule(item)}
//                           >
//                             Edit
//                           </button>
//                           <button
//                             className="delete-btn"
//                             onClick={() => deleteRule(item.id)}
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                   {rules.length === 0 && (
//                     <tr>
//                       <td colSpan="5" style={{ textAlign: "center" }}>No active rules found.</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* GOOGLE LINK */}
//         <div className="google-box">
//           <h2>Google Review Link Integrator</h2>
//           <p>Paste your original Google Business Review URL here.</p>
//           <div className="google-input">
//             <input
//               type="text"
//               placeholder="Paste Google Review URL..."
//               value={googleLink}
//               onChange={(e) => setGoogleLink(e.target.value)}
//             />
//             <button className="google-save" onClick={saveGoogleLink}>
//               Save Link
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import MerchantQRScreen from "./Merchenqr";
// import { useNavigate } from "react-router-dom";
// export default function MerchantLoyaltyRules() {
//   const [visitNumber, setVisitNumber] = useState("");
//   const [reward, setReward] = useState("");
//   const [googleLink, setGoogleLink] = useState("");
//   const [rules, setRules] = useState([]);
//   const [editingId, setEditingId] = useState(null);
// const navigate = useNavigate();
//   const MERCHANT_ID = "CMV9A117EAC"; // Aapki Merchant ID
// const [merchantInfo, setMerchantInfo] = useState(null);

//   // ==========================================
//   // FETCH MERCHANT/RESTAURANT DETAILS
//   // ==========================================
//   const fetchMerchantDetails = () => {
//     const formdata = new FormData();
//     formdata.append("user_id", MERCHANT_ID);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`https://countmyvisit.com/Apis/getmarchantdashdetails.php?user_id=${MERCHANT_ID}`, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         console.log("Raw Merchant Info Response:", result);
//         try {
//           // 🌟 DATABASE CONNECTED text ko remove karne ka logic
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace("DATABASE CONNECTED", "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.merchant) {
//             setMerchantInfo(parsedData.merchant); // Merchant object ko save kiya
//           }
//         } catch (e) {
//           console.error("Merchant info parse nahi ho payi:", e);
//         }
//       })
//       .catch((error) => console.error("Error fetching merchant details:", error));
//   };

//   // useEffect ke andar fetchRules ke sath ise bhi call kar dein
//   useEffect(() => {
//     fetchRules();
//     fetchMerchantDetails(); // 🌟 Nayi API call trigger ki
//   }, []);
//   // ==========================================
//   // 1. FETCH ALL PASSES (GET/POST DATA)
//   // ==========================================
//   // ==========================================
//   // 1. FETCH ALL PASSES (EXACTLY YOUR LOGIC WITH REACTION)
//   // ==========================================
//  const fetchRules = () => {
//     const formdata = new FormData();
//     formdata.append("merchant_id", MERCHANT_ID);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/get_merchant_passes.php", requestOptions)
//       .then((response) => response.text()) 
//       .then((result) => {
//         console.log("Raw Response From Server:", result);
        
//         try {
//           // 🌟 DATABASE CONNECTED text ko remove karne ka pakka ilaj
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace("DATABASE CONNECTED", "").trim();
//           }

//           // Ab saaf string ko parse karenge
//           const parsedData = JSON.parse(cleanJsonString); 
//           console.log("Parsed Data Success:", parsedData);
          
//           // Kyunki aapka array 'data' key ke andar hai, hum parsedData.data set karenge
//           if (parsedData && parsedData.data && Array.isArray(parsedData.data)) {
//             setRules(parsedData.data);
//           } else if (Array.isArray(parsedData)) {
//             setRules(parsedData);
//           } else {
//             setRules([]);
//           }
//         } catch (e) {
//           console.error("Data parse nahi ho paya, error ye hai:", e);
//           setRules([]);
//         }
//       })
//       .catch((error) => {
//         console.error("API Error:", error);
//         setRules([]);
//       });
//   };

//   useEffect(() => {
//     fetchRules();
//   }, []);
//   // ==========================================
//   // 2. ADD OR UPDATE PASS
//   // ==========================================
//   const addRule = () => {
//     if (!visitNumber || !reward) {
//       alert("Please fill all fields!");
//       return;
//     }

//     if (editingId) {
//       // ------- EDIT PASS CODE -------
//       const formdata = new FormData();
//       formdata.append("id", editingId);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       formdata.append("total_visits", visitNumber);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow",
//       };

//       // Space fix kar di query param ki
//       fetch(`https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`, requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           console.log("Edit Server Response:", result);
//           alert("Pass Updated Successfully!");
//           setEditingId(null);
//           setVisitNumber("");
//           setReward("");
//           fetchRules(); // Table reload karne ke liye
//         })
//         .catch((error) => console.error("Error editing pass:", error));

//     } else {
//       // ------- ADD NEW PASS CODE -------
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       formdata.append("total_visits", visitNumber);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow",
//       };

//       fetch("https://countmyvisit.com/Apis/add_loyalty_pass.php", requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           console.log("Add Server Response:", result);
//           alert("New Pass Added Successfully!");
//           setVisitNumber("");
//           setReward("");
//           fetchRules(); // Table reload karne ke liye
//         })
//         .catch((error) => console.error("Error adding pass:", error));
//     }
//   };

//   // Edit click karne par form field fill karne ke liye
//   const handleEditClick = (item) => {
//     setVisitNumber(item.total_visits || "");
//     setReward(item.reward || "");
//     setEditingId(item.id);
//   };

//   // ==========================================
//   // 3. DELETE PASS
//   // ==========================================
//  const deleteRule = (id) => {
//     if (!window.confirm("Are you sure you want to delete this pass?")) return;

//     // 🌟 Sirf FormData banayein, kyunki backend body se data read karega
//     const formdata = new FormData();
//     formdata.append("id", String(id));

//     const requestOptions = {
//       method: "POST",
//       body: formdata, // Koi custom header nahi bhejenge taaki CORS error na aaye
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/delete_loyalty_pass.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         console.log("Delete Server Response:", result);
//         alert("Pass Deleted Successfully!");
//         fetchRules(); // Table reload karne ke liye fresh data pull karein
//       })
//       .catch((error) => console.error("Error deleting pass:", error));
//   };

//   const saveGoogleLink = () => {
//     alert("Google Review Link Saved Successfully");
//   };

//   return (
//     <>
//       <style>{`
//         *{ margin:0; padding:0; box-sizing:border-box; font-family:'Poppins',sans-serif; }
//         body{ background:#f5f7fb; }
//         .merchant-page{ min-height:100vh; padding:35px; background: linear-gradient(135deg,#fff7ed,#fff,#eef4ff); }
//         .top-header{ display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:20px; margin-bottom:35px; }
//         .top-header h1{ font-size:42px; font-weight:800; color:#111827; margin-bottom:8px; }
//         .top-header p{ color:#6b7280; font-size:16px; }
//         .merchant-logo{ width:75px; height:75px; border-radius:24px; background: linear-gradient(135deg,#ff8c42,#ff5e62); color:white; display:flex; align-items:center; justify-content:center; font-size:34px; box-shadow:0 15px 30px rgba(255,94,98,0.3); }
//         .main-grid{ display:grid; grid-template-columns:420px 1fr; gap:30px; }
//         .card{ background:white; border-radius:35px; padding:35px; box-shadow:0 15px 45px rgba(0,0,0,0.06); }
//         .card h2{ font-size:30px; margin-bottom:12px; color:#111827; }
//         .card p{ color:#6b7280; line-height:1.7; margin-bottom:30px; }
//         .input-group{ margin-bottom:22px; }
//         .input-group label{ display:block; margin-bottom:12px; font-size:15px; font-weight:700; color:#374151; }
//         .input-group input{ width:100%; height:65px; border:none; background:#f9fafb; border-radius:18px; padding:0 20px; font-size:16px; outline:none; transition:0.3s; }
//         .input-group input:focus{ background:white; box-shadow:0 0 0 4px rgba(255,140,66,0.15); }
//         .save-btn{ width:100%; height:65px; border:none; border-radius:18px; background: linear-gradient(135deg,#ff8c42,#ff5e62); color:white; font-size:18px; font-weight:700; cursor:pointer; transition:0.3s; }
//         .save-btn:hover{ transform:translateY(-3px); box-shadow:0 15px 30px rgba(255,94,98,0.3); }
//         .table-container{ overflow:auto; }
//         table{ width:100%; border-collapse:collapse; min-width:700px; }
//         th{ background:#fff7ed; color:#111827; padding:18px; text-align:left; font-size:15px; }
//         td{ padding:20px 18px; border-bottom:1px solid #eee; color:#4b5563; font-size:15px; }
//         tr:hover{ background:#fafafa; }
//         .badge{ display:inline-block; padding:10px 18px; border-radius:30px; background:#ecfdf5; color:#059669; font-size:13px; font-weight:700; }
//         .actions{ display:flex; gap:12px; }
//         .edit-btn{ border:none; padding:10px 18px; border-radius:14px; background:#fff7ed; color:#ff6b35; font-weight:700; cursor:pointer; }
//         .delete-btn{ border:none; padding:10px 18px; border-radius:14px; background:#fee2e2; color:#dc2626; font-weight:700; cursor:pointer; }
//         .google-box{ margin-top:35px; background: linear-gradient(135deg,#111827,#1f2937); border-radius:30px; padding:35px; color:white; }
//         .google-box h2{ color:white; margin-bottom:15px; }
//         .google-box p{ color:#d1d5db; margin-bottom:25px; }
//         .google-input{ display:flex; gap:15px; flex-wrap:wrap; }
//         .google-input input{ flex:1; min-width:220px; height:65px; border:none; border-radius:18px; padding:0 20px; font-size:16px; outline:none; }
//         .google-save{ padding:0 30px; border:none; border-radius:18px; background:#ff8c42; color:white; font-size:16px; font-weight:700; cursor:pointer; transition:0.3s; }
//         .google-save:hover{ background:#ff6b35; }
//         @media(max-width:1000px){ .main-grid{ grid-template-columns:1fr; } }
//         @media(max-width:768px){ .merchant-page{ padding:20px; } .top-header h1{ font-size:30px; } .card{ padding:25px; } .card h2{ font-size:25px; } }
//       `}</style>

//       <div className="merchant-page">
//         {/* HEADER */}
//         {/* HEADER WITH RESTAURANT INFORMATION */}
//         <div className="top-header" style={{
//           background: "white",
//           padding: "25px 35px",
//           borderRadius: "24px",
//           boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "35px"
//         }}>
//         <div>
//          <h1  onClick={() => navigate("/MerchantQRScreen")} style={{ fontSize: "25px", fontWeights: "800", color: "#111827", margin: 0, textTransform: "capitalize" }}> DownloadQR</h1>
//         </div>
//           <div>
//             {merchantInfo ? (
//               <>
//                 <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
//                   {/* Business Name (Capitalized) */}
//                   <h1 style={{ fontSize: "36px", fontWeights: "800", color: "#111827", margin: 0, textTransform: "capitalize" }}>
//                     {merchantInfo.business_name} Dashboard
//                   </h1>
//                   {/* Business Type Badge */}
//                   <span style={{
//                     background: "#e0f2fe",
//                     color: "#0369a1",
//                     padding: "4px 12px",
//                     borderRadius: "20px",
//                     fontSize: "12px",
//                     fontWeight: "700",
//                     textTransform: "uppercase"
//                   }}>
//                     {merchantInfo.business_type}
//                   </span>
//                 </div>
//                 {/* Owner Name and Address details */}
//                 <p style={{ color: "#6b7280", fontSize: "15px", margin: 0 }}>
//                   Welcome back, <strong style={{ color: "#111827", textTransform: "capitalize" }}>{merchantInfo.owner_name}</strong> | 📍 {merchantInfo.address}
//                 </p>
//               </>
//             ) : (
//               <>
//                 <h1 style={{ fontSize: "36px", fontWeight: "800", color: "#111827", margin: 0 }}>
//                   Loading Dashboard...
//                 </h1>
//                 <p style={{ color: "#6b7280", fontSize: "15px", margin: 0 }}>
//                   Fetching your restaurant configurations.
//                 </p>
//               </>
//             )}
//           </div>
          
//           {/* Logo with first letter of restaurant name */}
//           <div className="merchant-logo" style={{
//             textTransform: "uppercase",
//             fontWeight: "bold",
//             fontSize: "28px"
//           }}>
//             {merchantInfo && merchantInfo.business_name ? merchantInfo.business_name.charAt(0) : "🍽️"}
//           </div>
//         </div>

//         {/* MAIN INTERFACE GRID */}
//         <div className="main-grid">
//           {/* LEFT FORM */}
//           <div className="card">
//             <h2>Dynamic Rule Creator</h2>
//             <p>Configure custom loyalty rewards based on customer visits.</p>

//             <div className="input-group">
//               <label>Visit Number</label>
//               <input
//                 type="number"
//                 placeholder="e.g. 4"
//                 value={visitNumber}
//                 onChange={(e) => setVisitNumber(e.target.value)}
//               />
//             </div>

//             <div className="input-group">
//               <label>Reward Details</label>
//               <input
//                 type="text"
//                 placeholder="e.g. Free Coffee"
//                 value={reward}
//                 onChange={(e) => setReward(e.target.value)}
//               />
//             </div>

//             <button className="save-btn" onClick={addRule}>
//               {editingId ? "Update Rule 🔄" : "Add Rule ➕"}
//             </button>
//           </div>

//           {/* RIGHT LIVE DATATABLE */}
//            <div className="card">
//   <h2>Active Campaign Management</h2>
//   <p>Manage all active loyalty campaigns and reward configurations.</p>

//   <div className="table-container">
//     <table>
//       <thead>
//         <tr>
//           <th>Sl No</th>
//           <th>Campaign Title</th>
//           <th>Total Visits Required</th>
//           <th>Reward Details</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {rules && rules.length > 0 ? (
//           rules.map((item, index) => (
//             <tr key={item.id || index}>
//               <td>{index + 1}</td>
//               {/* Agar title khali hoga toh automatic 'Visit X Times' bana dega */}
//               <td>{item.title || `Visit ${item.total_visits} Times`}</td>
//               <td>
//                 <strong>{item.total_visits ?? "0"}</strong> Visits
//               </td>
//               {/* Agar reward empty string "" hai to dash (-) dikhayega */}
//               <td>{item.reward ? item.reward : <span style={{ color: "#9ca3af" }}>-</span>}</td>
//               <td>
//                 <span 
//                   className="badge" 
//                   style={{
//                     background: item.status === "active" ? "#ecfdf5" : "#f3f4f6",
//                     color: item.status === "active" ? "#059669" : "#6b7280"
//                   }}
//                 >
//                   {item.status ? item.status.toUpperCase() : "ACTIVE"}
//                 </span>
//               </td>
//               <td>
//                 <div className="actions">
//                   <button
//                     className="edit-btn"
//                     onClick={() => handleEditClick(item)}
//                   >
//                     Edit
//                   </button>
//                   <button
//                     className="delete-btn"
//                     onClick={() => deleteRule(item.id)}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </td>
//             </tr>
//           ))
//         ) : (
//           <tr>
//             <td colSpan="6" style={{ textAlign: "center", padding: "30px", color: "#9ca3af" }}>
//               No active passes found in database.
//             </td>
//           </tr>
//         )}
//       </tbody>
//     </table>
//   </div>
// </div>
//         </div>

//         {/* GOOGLE LINK */}
//         <div className="google-box">
//           <h2>Google Review Link Integrator</h2>
//           <p>Paste your original Google Business Review URL here.</p>
//           <div className="google-input">
//             <input
//               type="text"
//               placeholder="Paste Google Review URL..."
//               value={googleLink}
//               onChange={(e) => setGoogleLink(e.target.value)}
//             />
//             <button className="google-save" onClick={saveGoogleLink}>
//               Save Link
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function MerchantLoyaltyRules() {
//   const navigate = useNavigate();
  
//   // State definitions
//   const [visitNumber, setVisitNumber] = useState("");
//   const [reward, setReward] = useState("");
//   const [googleLink, setGoogleLink] = useState("");
//   const [rules, setRules] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [merchantInfo, setMerchantInfo] = useState(null);
//   const [merchantId, setMerchantId] = useState("");

//   // ==========================================
//   // INITIALIZE DYNAMIC DATA FROM LOCALSTORAGE
//   // ==========================================
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
//         // Login API response structure: parsedData.merchant.user_id
//         if (parsedData && parsedData.merchant) {
//           setMerchantInfo(parsedData.merchant);
//           setMerchantId(parsedData.merchant.user_id);
//           return;
//         }
//       }
//       // If no valid data is found in localStorage, redirect back to login
//       console.warn("No merchant data found in localStorage. Redirecting to login.");
//       // navigate("/login"); // Optional: uncomment this to enforce route security
//     } catch (error) {
//       console.error("Error reading localStorage:", error);
//     }
//   }, [navigate]);

//   // Trigger API calls only when dynamic merchantId is set
//   useEffect(() => {
//     if (merchantId) {
//       fetchRules();
//       fetchMerchantDetails();
//     }
//   }, [merchantId]);

//   // ==========================================
//   // FETCH MERCHANT/RESTAURANT DETAILS DYNAMICALLY
//   // ==========================================
//   const fetchMerchantDetails = () => {
//     if (!merchantId) return;

//     const formdata = new FormData();
//     formdata.append("user_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`https://countmyvisit.com/Apis/getmarchantdashdetails.php?user_id=${merchantId}`, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace("DATABASE CONNECTED", "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.merchant) {
//             setMerchantInfo(parsedData.merchant);
//           }
//         } catch (e) {
//           console.error("Merchant info parse error:", e);
//         }
//       })
//       .catch((error) => console.error("Error fetching merchant details:", error));
//   };

//   // ==========================================
//   // FETCH ALL PASSES DYNAMICALLY
//   // ==========================================
//   const fetchRules = () => {
//     if (!merchantId) return;

//     const formdata = new FormData();
//     formdata.append("merchant_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/get_merchant_passes.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace("DATABASE CONNECTED", "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData && parsedData.data && Array.isArray(parsedData.data)) {
//             setRules(parsedData.data);
//           } else if (Array.isArray(parsedData)) {
//             setRules(parsedData);
//           } else {
//             setRules([]);
//           }
//         } catch (e) {
//           console.error("Data parse error:", e);
//           setRules([]);
//         }
//       })
//       .catch((error) => {
//         console.error("API Error:", error);
//         setRules([]);
//       });
//   };

//   // ==========================================
//   // ADD OR UPDATE PASS DYNAMICALLY
//   // ==========================================
//   const addRule = () => {
//     if (!visitNumber || !reward) {
//       alert("Please fill all fields!");
//       return;
//     }
//     if (!merchantId) {
//       alert("Merchant Authentication missing. Please log in again.");
//       return;
//     }

//     if (editingId) {
//       const formdata = new FormData();
//       formdata.append("id", editingId);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       formdata.append("total_visits", visitNumber);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow",
//       };

//       fetch(`https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`, requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           alert("Pass Updated Successfully! 🎉");
//           setEditingId(null);
//           setVisitNumber("");
//           setReward("");
//           fetchRules();
//         })
//         .catch((error) => console.error("Error editing pass:", error));

//     } else {
//       const formdata = new FormData();
//       formdata.append("merchant_id", merchantId);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       formdata.append("total_visits", visitNumber);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow",
//       };

//       fetch("https://countmyvisit.com/Apis/add_loyalty_pass.php", requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           alert("New Pass Added Successfully! 🚀");
//           setVisitNumber("");
//           setReward("");
//           fetchRules();
//         })
//         .catch((error) => console.error("Error adding pass:", error));
//     }
//   };

//   const handleEditClick = (item) => {
//     setVisitNumber(item.total_visits || "");
//     setReward(item.reward || "");
//     setEditingId(item.id);
//   };

//   // ==========================================
//   // DELETE PASS
//   // ==========================================
//   const deleteRule = (id) => {
//     if (!window.confirm("Are you sure you want to delete this pass?")) return;

//     const formdata = new FormData();
//     formdata.append("id", String(id));

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/delete_loyalty_pass.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         alert("Pass Deleted Successfully!");
//         fetchRules();
//       })
//       .catch((error) => console.error("Error deleting pass:", error));
//   };

//   const saveGoogleLink = () => {
//     if (!googleLink) {
//       alert("Please enter a valid link first!");
//       return;
//     }
//     alert("Google Review Link Integrator Matrix Updated Successfully!");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("marchentdata");
//     navigate("/login"); // Adjust route as per setup
//   };

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; }
//         .merchant-page { min-height: 100vh; padding: 24px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); }
        
//         /* Premium Dynamic Navigation Bar */
//         .premium-nav {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           background: #ffffff;
//           padding: 16px 32px;
//           border-radius: 20px;
//           box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05);
//           margin-bottom: 30px;
//           border: 1px solid rgba(255, 255, 255, 0.8);
//         }
//         .nav-logo-side { display: flex; align-items: center; gap: 14px; }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
//         .nav-actions { display: flex; gap: 12px; align-items: center; }
        
//         /* Nav Buttons */
//         .nav-btn {
//           padding: 10px 20px;
//           font-size: 14px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           border: none;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .btn-primary-nav { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.25); }
//         .btn-primary-nav:hover { opacity: 0.95; transform: translateY(-1px); }
//         .btn-secondary-nav { background: #f1f5f9; color: #475569; }
//         .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }
//         .btn-danger-nav { background: #fee2e2; color: #ef4444; }
//         .btn-danger-nav:hover { background: #fca5a5; color: #991b1b; }

//         /* Dashboard Top Info Card */
//         .top-header {
//           background: #ffffff;
//           padding: 30px;
//           border-radius: 24px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 30px;
//           border-left: 6px solid #ff8c42;
//         }
//         .merchant-title { font-size: 32px; font-weight: 800; color: #0f172a; text-transform: capitalize; }
//         .merchant-logo { width: 64px; height: 64px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 26px; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }
        
//         /* Grid Rules Layout */
//         .main-grid { display: grid; grid-template-columns: 400px 1fr; gap: 30px; }
//         .card { background: white; border-radius: 24px; padding: 32px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #f1f5f9; }
//         .card h2 { font-size: 24px; margin-bottom: 8px; color: #0f172a; font-weight: 700; }
//         .card p { color: #64748b; font-size: 14px; margin-bottom: 24px; }
        
//         /* Inputs Control styling */
//         .input-group { margin-bottom: 20px; }
//         .input-group label { display: block; margin-bottom: 8px; font-size: 13px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; }
//         .input-group input { width: 100%; height: 54px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 14px; padding: 0 16px; font-size: 15px; outline: none; transition: all 0.25s ease; }
//         .input-group input:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.15); }
        
//         .save-btn { width: 100%; height: 54px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); }
//         .save-btn:hover { transform: translateY(-2px); opacity: 0.95; }
        
//         /* Tables Core Engine */
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; }
//         table { width: 100%; border-collapse: collapse; min-width: 650px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 16px; font-size: 14px; font-weight: 700; border-bottom: 2px solid #e2e8f0; }
//         td { padding: 16px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
//         tr:hover { background: #f8fafc; }
        
//         /* Badges & Actions UI */
//         .badge { display: inline-block; padding: 6px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
//         .actions { display: flex; gap: 10px; }
//         .edit-btn { border: none; padding: 8px 14px; border-radius: 10px; background: #fff7ed; color: #ea580c; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .edit-btn:hover { background: #ffedd5; }
//         .delete-btn { border: none; padding: 8px 14px; border-radius: 10px; background: #fee2e2; color: #ef4444; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .delete-btn:hover { background: #fca5a5; color: #991b1b; }
        
//         /* Google Integrator section */
//         .google-box { margin-top: 30px; background: linear-gradient(135deg, #0f172a, #1e293b); border-radius: 24px; padding: 32px; color: white; }
//         .google-box h2 { color: white; }
//         .google-box p { color: #94a3b8; }
//         .google-input { display: flex; gap: 12px; flex-wrap: wrap; }
//         .google-input input { flex: 1; min-width: 250px; height: 54px; border: 1px solid #334155; background: rgba(255,255,255,0.05); border-radius: 14px; padding: 0 16px; font-size: 15px; color: white; outline: none; }
//         .google-input input:focus { border-color: #ff8c42; background: rgba(255,255,255,0.08); }
//         .google-save { padding: 0 28px; border: none; border-radius: 14px; background: #ff8c42; color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .google-save:hover { background: #f97316; transform: translateY(-1px); }

//         @media(max-width: 1100px){ .main-grid { grid-template-columns: 1fr; } }
//         @media(max-width: 768px){ .premium-nav { padding: 16px; flex-direction: column; gap: 16px; text-align: center; } }
//       `}</style>

//       <div className="merchant-page">
        
//         {/* NEW ADVANCED PRO NAVIGATION BAR */}
//         <nav className="premium-nav">
//           <div className="nav-logo-side">
//             <span style={{ fontSize: "24px" }}>📊</span>
//             <span className="nav-brand">Count My Visit Workspace</span>
//           </div>
//           <div className="nav-actions">
//             <button className="nav-btn btn-secondary-nav" onClick={() => fetchRules()}>
//               🔄 Refresh Data
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantQRScreen")}>
//               📱 Download QR Code
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/merchantanalytics")}>
//              Merchant Feedback 
//             </button>
//             <button className="nav-btn btn-danger-nav" onClick={handleLogout}>
//               🚪 Logout
//             </button>
//           </div>
//         </nav>

//         {/* RESTAURANT PROFILE HEADER (DYNAMICALLY RENDERED) */}
//         <div className="top-header">
//           <div>
//             {merchantInfo ? (
//               <>
//                 <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
//                   <h1 className="merchant-title">{merchantInfo.business_name || "Workspace"}</h1>
//                   <span className="badge" style={{ background: "#e0f2fe", color: "#0369a1" }}>
//                     {merchantInfo.business_type || "Merchant"}
//                   </span>
//                 </div>
//                 <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
//                   Welcome back, <strong style={{ color: "#0f172a" }}>{merchantInfo.owner_name}</strong> | 📍 {merchantInfo.address || "Location Active"}
//                 </p>
//               </>
//             ) : (
//               <>
//                 <h1 style={{ fontSize: "28px", fontWeight: "800", color: "#0f172a" }}>Loading Real-time Configuration...</h1>
//                 <p style={{ color: "#64748b", fontSize: "14px" }}>Synchronizing backend workspace keys safely.</p>
//               </>
//             )}
//           </div>
//           <div className="merchant-logo">
//             {merchantInfo && merchantInfo.business_name ? merchantInfo.business_name.charAt(0).toUpperCase() : "☕"}
//           </div>
//         </div>

//         {/* INTERFACE GRID SPLIT */}
//         <div className="main-grid">
          
//           {/* RULE CREATOR CARD */}
//           <div className="card">
//             <h2>Dynamic Rule Creator</h2>
//             <p>Configure automated multi-visit loyalty triggers for customers metrics.</p>

//             <div className="input-group">
//               <label>Target Visit Count</label>
//               <input
//                 type="number"
//                 placeholder="e.g. 5"
//                 value={visitNumber}
//                 onChange={(e) => setVisitNumber(e.target.value)}
//               />
//             </div>

//             <div className="input-group">
//               <label>Reward Parameters</label>
//               <input
//                 type="text"
//                 placeholder="e.g. 15% Off Total Bill"
//                 value={reward}
//                 onChange={(e) => setReward(e.target.value)}
//               />
//             </div>

//             <button className="save-btn" onClick={addRule}>
//               {editingId ? "Modify Loyalty Ruleset 🔄" : "Deploy Live Campaign ➕"}
//             </button>
//           </div>

//           {/* DYNAMIC DATATABLE */}
//           <div className="card">
//             <h2>Active Campaign Management</h2>
//             <p>Track, calibrate, or discard real-time checkout incentive campaigns.</p>

//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>S.No</th>
//                     <th>Campaign Title</th>
//                     <th>Visits Required</th>
//                     <th>Reward Pipeline</th>
//                     <th>State</th>
//                     <th>Control Panel</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rules && rules.length > 0 ? (
//                     rules.map((item, index) => (
//                       <tr key={item.id || index}>
//                         <td>{index + 1}</td>
//                         <td>{item.title || `Visit ${item.total_visits} Times`}</td>
//                         <td><strong>{item.total_visits ?? "0"}</strong> Visits</td>
//                         <td>{item.reward ? item.reward : <span style={{ color: "#94a3b8" }}>-</span>}</td>
//                         <td>
//                           <span 
//                             className="badge" 
//                             style={{
//                               background: item.status === "active" ? "#dcfce7" : "#f1f5f9",
//                               color: item.status === "active" ? "#15803d" : "#475569"
//                             }}
//                           >
//                             {item.status ? item.status.toUpperCase() : "ACTIVE"}
//                           </span>
//                         </td>
//                         <td>
//                           <div className="actions">
//                             <button className="edit-btn" onClick={() => handleEditClick(item)}>Edit</button>
//                             <button className="delete-btn" onClick={() => deleteRule(item.id)}>Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="6" style={{ textAlign: "center", padding: "40px", color: "#94a3b8" }}>
//                         No active metrics deployment cards found inside target account ruleset.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* GOOGLE LINK MANAGEMENT */}
//         <div className="google-box">
//           <h2>Google Review Link Integrator</h2>
//           <p>Sync your Google Map Business page reviews seamlessly to bootstrap reputation algorithms.</p>
//           <div className="google-input">
//             <input
//               type="text"
//               placeholder="https://g.page/r/your-business-profile/review"
//               value={googleLink}
//               onChange={(e) => setGoogleLink(e.target.value)}
//             />
//             <button className="google-save" onClick={saveGoogleLink}>
//               Commit Changes
//             </button>
//           </div>
//         </div>

//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function MerchantLoyaltyRules() {
//   const navigate = useNavigate();
  
//   // State definitions
//   const [visitNumber, setVisitNumber] = useState("");
//   const [reward, setReward] = useState("");
//   const [googleLink, setGoogleLink] = useState("");
//   const [rules, setRules] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [merchantInfo, setMerchantInfo] = useState(null);
//   const [merchantId, setMerchantId] = useState("");

//   // Subscription Status States
//   const [subscription, setSubscription] = useState({
//     active: false,
//     daysLeft: 0,
//     planName: "",
//     loaded: false
//   });
 
//   // ==========================================
//   // INITIALIZE DYNAMIC DATA FROM LOCALSTORAGE
//   // ==========================================
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
//         if (parsedData && parsedData.merchant) {
//           setMerchantInfo(parsedData.merchant);
//           setMerchantId(parsedData.merchant.user_id);
//           return;
//         }
//       }
//       console.warn("No merchant data found in localStorage. Redirecting to login.");
//     } catch (error) {
//       console.error("Error reading localStorage:", error);
//     }
//   }, [navigate]);

//   // Trigger API calls only when dynamic merchantId is set
//   useEffect(() => {
//     if (merchantId) {
//       checkSubscription();
//       fetchRules();
//       fetchMerchantDetails();
//     }
//   }, [merchantId]);

//   // ==========================================
//   // CHECK SUBSCRIPTION STATUS
//   // ==========================================
//   const checkSubscription = () => {
//     if (!merchantId) return;

//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

//     const urlencoded = new URLSearchParams();
//     urlencoded.append("merchant_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: urlencoded,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/check_subscription.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.subscription_active) {
//             setSubscription({
//               active: true,
//               daysLeft: parsedData.days_left,
//               planName: parsedData.plan_name,
//               loaded: true
//             });
//           } else {
//             setSubscription({
//               active: false,
//               daysLeft: 0,
//               planName: "",
//               loaded: true
//             });
//           }
//         } catch (e) {
//           console.error("Subscription parse error:", e);
//           setSubscription((prev) => ({ ...prev, loaded: true }));
//         }
//       })
//       .catch((error) => {
//         console.error("Error checking subscription:", error);
//         setSubscription((prev) => ({ ...prev, loaded: true }));
//       });
//   };

//   // ==========================================
//   // FETCH MERCHANT/RESTAURANT DETAILS DYNAMICALLY
//   // ==========================================
//   const fetchMerchantDetails = () => {
//     if (!merchantId) return;

//     const formdata = new FormData();
//     formdata.append("user_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`https://countmyvisit.com/Apis/getmarchantdashdetails.php?user_id=${merchantId}`, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.merchant) {
//             setMerchantInfo(parsedData.merchant);
//           }
//         } catch (e) {
//           console.error("Merchant info parse error:", e);
//         }
//       })
//       .catch((error) => console.error("Error fetching merchant details:", error));
//   };

//   // ==========================================
//   // FETCH ALL PASSES DYNAMICALLY
//   // ==========================================
//   const fetchRules = () => {
//     if (!merchantId) return;

//     const formdata = new FormData();
//     formdata.append("merchant_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/get_merchant_passes.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData && parsedData.data && Array.isArray(parsedData.data)) {
//             setRules(parsedData.data);
//           } else if (Array.isArray(parsedData)) {
//             setRules(parsedData);
//           } else {
//             setRules([]);
//           }
//         } catch (e) {
//           console.error("Data parse error:", e);
//           setRules([]);
//         }
//       })
//       .catch((error) => {
//         console.error("API Error:", error);
//         setRules([]);
//       });
//   };

//   // ==========================================
//   // ADD OR UPDATE PASS DYNAMICALLY
//   // ==========================================
//   const addRule = () => {
//     if (!visitNumber || !reward) {
//       alert("Please fill all fields!");
//       return;
//     }
//     if (!merchantId) {
//       alert("Merchant Authentication missing. Please log in again.");
//       return;
//     }

//     if (editingId) {
//       const formdata = new FormData();
//       formdata.append("id", editingId);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       formdata.append("total_visits", visitNumber);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow",
//       };

//       fetch(`https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`, requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           alert("Pass Updated Successfully! 🎉");
//           setEditingId(null);
//           setVisitNumber("");
//           setReward("");
//           fetchRules();
//         })
//         .catch((error) => console.error("Error editing pass:", error));

//     } else {
//       const formdata = new FormData();
//       formdata.append("merchant_id", merchantId);
//       formdata.append("title", `Visit ${visitNumber} Times`);
//       formdata.append("reward", reward);
//       formdata.append("total_visits", visitNumber);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow",
//       };

//       fetch("https://countmyvisit.com/Apis/add_loyalty_pass.php", requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           alert("New Pass Added Successfully! 🚀");
//           setVisitNumber("");
//           setReward("");
//           fetchRules();
//         })
//         .catch((error) => console.error("Error adding pass:", error));
//     }
//   };

//   const handleEditClick = (item) => {
//     setVisitNumber(item.total_visits || "");
//     setReward(item.reward || "");
//     setEditingId(item.id);
//   };

//   // ==========================================
//   // DELETE PASS
//   // ==========================================
//   const deleteRule = (id) => {
//     if (!window.confirm("Are you sure you want to delete this pass?")) return;

//     const formdata = new FormData();
//     formdata.append("id", String(id));

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/delete_loyalty_pass.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         alert("Pass Deleted Successfully!");
//         fetchRules();
//       })
//       .catch((error) => console.error("Error deleting pass:", error));
//   };

//   const saveGoogleLink = () => {
//     if (!googleLink) {
//       alert("Please enter a valid link first!");
//       return;
//     }
//     alert("Google Review Link Integrator Matrix Updated Successfully!");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("marchentdata");
//     navigate("/login");
//   };

//   const handleRenewSubscription = () => {
//     // Navigate to subscription payment page or trigger gateway
//     navigate("/MerchantSubs");
//   };

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; }
//         .merchant-page { min-height: 100vh; padding: 24px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); }
        
//         /* Subscription Alert Trackers */
//         .sub-status-bar { display: flex; justify-content: space-between; align-items: center; padding: 14px 24px; border-radius: 16px; margin-bottom: 24px; font-weight: 600; font-size: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.02); }
//         .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
//         .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
//         .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 13px; }
//         .sub-renew-btn { background: #ef4444; color: white; border: none; padding: 8px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 10px rgba(239, 68, 68, 0.2); }
//         .sub-renew-btn:hover { background: #dc2626; transform: translateY(-1px); }

//         /* Premium Dynamic Navigation Bar */
//         .premium-nav {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           background: #ffffff;
//           padding: 16px 32px;
//           border-radius: 20px;
//           box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05);
//           margin-bottom: 30px;
//           border: 1px solid rgba(255, 255, 255, 0.8);
//         }
//         .nav-logo-side { display: flex; align-items: center; gap: 14px; }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
//         .nav-actions { display: flex; gap: 12px; align-items: center; }
        
//         /* Nav Buttons */
//         .nav-btn {
//           padding: 10px 20px;
//           font-size: 14px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           border: none;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .btn-primary-nav { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.25); }
//         .btn-primary-nav:hover { opacity: 0.95; transform: translateY(-1px); }
//         .btn-secondary-nav { background: #f1f5f9; color: #475569; }
//         .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }
//         .btn-danger-nav { background: #fee2e2; color: #ef4444; }
//         .btn-danger-nav:hover { background: #fca5a5; color: #991b1b; }

//         /* Dashboard Top Info Card */
//         .top-header {
//           background: #ffffff;
//           padding: 30px;
//           border-radius: 24px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 30px;
//           border-left: 6px solid #ff8c42;
//         }
//         .merchant-title { font-size: 32px; font-weight: 800; color: #0f172a; text-transform: capitalize; }
//         .merchant-logo { width: 64px; height: 64px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 26px; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }
        
//         /* Grid Rules Layout */
//         .main-grid { display: grid; grid-template-columns: 400px 1fr; gap: 30px; }
//         .card { background: white; border-radius: 24px; padding: 32px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #f1f5f9; }
//         .card h2 { font-size: 24px; margin-bottom: 8px; color: #0f172a; font-weight: 700; }
//         .card p { color: #64748b; font-size: 14px; margin-bottom: 24px; }
        
//         /* Inputs Control styling */
//         .input-group { margin-bottom: 20px; }
//         .input-group label { display: block; margin-bottom: 8px; font-size: 13px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; }
//         .input-group input { width: 100%; height: 54px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 14px; padding: 0 16px; font-size: 15px; outline: none; transition: all 0.25s ease; }
//         .input-group input:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.15); }
        
//         .save-btn { width: 100%; height: 54px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); }
//         .save-btn:hover { transform: translateY(-2px); opacity: 0.95; }
        
//         /* Tables Core Engine */
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; }
//         table { width: 100%; border-collapse: collapse; min-width: 650px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 16px; font-size: 14px; font-weight: 700; border-bottom: 2px solid #e2e8f0; }
//         td { padding: 16px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
//         tr:hover { background: #f8fafc; }
        
//         /* Badges & Actions UI */
//         .badge { display: inline-block; padding: 6px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
//         .actions { display: flex; gap: 10px; }
//         .edit-btn { border: none; padding: 8px 14px; border-radius: 10px; background: #fff7ed; color: #ea580c; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .edit-btn:hover { background: #ffedd5; }
//         .delete-btn { border: none; padding: 8px 14px; border-radius: 10px; background: #fee2e2; color: #ef4444; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .delete-btn:hover { background: #fca5a5; color: #991b1b; }
        
//         /* Google Integrator section */
//         .google-box { margin-top: 30px; background: linear-gradient(135deg, #0f172a, #1e293b); border-radius: 24px; padding: 32px; color: white; }
//         .google-box h2 { color: white; }
//         .google-box p { color: #94a3b8; }
//         .google-input { display: flex; gap: 12px; flex-wrap: wrap; }
//         .google-input input { flex: 1; min-width: 250px; height: 54px; border: 1px solid #334155; background: rgba(255,255,255,0.05); border-radius: 14px; padding: 0 16px; font-size: 15px; color: white; outline: none; }
//         .google-input input:focus { border-color: #ff8c42; background: rgba(255,255,255,0.08); }
//         .google-save { padding: 0 28px; border: none; border-radius: 14px; background: #ff8c42; color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .google-save:hover { background: #f97316; transform: translateY(-1px); }

//         @media(max-width: 1100px){ .main-grid { grid-template-columns: 1fr; } }
//         @media(max-width: 768px){ .premium-nav { padding: 16px; flex-direction: column; gap: 16px; text-align: center; } }
//       `}</style>

//       <div className="merchant-page">
        
//         {/* NEW ADVANCED PRO NAVIGATION BAR */}
//         <nav className="premium-nav">
//           <div className="nav-logo-side">
//             <span style={{ fontSize: "24px" }}>📊</span>
//             <span className="nav-brand">Count My Visit Workspace</span>
//           </div>
//           <div className="nav-actions">
//             <button className="nav-btn btn-secondary-nav" onClick={() => { fetchRules(); checkSubscription(); }}>
//               🔄 Refresh Data
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantQRScreen")}>
//               📱 Download QR Code
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/merchantanalytics")}>
//               Merchant Feedback 
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantSubs")}>
//               Renew 
//             </button>
//              <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScanner")}>
//               SCAN QR
//             </button>
//               <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScanner")}>
//               SCAN QR radeem
//             </button>
//             <button className="nav-btn btn-danger-nav" onClick={handleLogout}>
//               🚪 Logout
//             </button>
//           </div>
//         </nav>

//         {/* DYNAMIC SUBSCRIPTION ALERTS PANEL */}
//         {subscription.loaded && (
//           subscription.active ? (
//             <div className="sub-status-bar sub-active-bar">
//               <span>Verified Account ✔️ Plan: {subscription.planName}</span>
//               <span className="sub-days-count">⏳ {subscription.daysLeft} Days Left</span>
//             </div>
//           ) : (
//             <div className="sub-status-bar sub-expired-bar">
//               <span>⚠️ No Active Subscription Found! Please renew to keep metrics campaigns operational.</span>
//               <button className="sub-renew-btn" onClick={handleRenewSubscription}>⚡ Renew Subscription</button>
//             </div>
//           )
//         )}

//         {/* RESTAURANT PROFILE HEADER (DYNAMICALLY RENDERED) */}
//         <div className="top-header">
//           <div>
//             {merchantInfo ? (
//               <>
//                 <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
//                   <h1 className="merchant-title">{merchantInfo.business_name || "Workspace"}</h1>
//                   <span className="badge" style={{ background: "#e0f2fe", color: "#0369a1" }}>
//                     {merchantInfo.business_type || "Merchant"}
//                   </span>
//                 </div>
//                 <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
//                   Welcome back, <strong style={{ color: "#0f172a" }}>{merchantInfo.owner_name}</strong> | 📍 {merchantInfo.address || "Location Active"}
//                 </p>
//               </>
//             ) : (
//               <>
//                 <h1 style={{ fontSize: "28px", fontWeight: "800", color: "#0f172a" }}>Loading Real-time Configuration...</h1>
//                 <p style={{ color: "#64748b", fontSize: "14px" }}>Synchronizing backend workspace keys safely.</p>
//               </>
//             )}
//           </div>
//           <div className="merchant-logo">
//             {merchantInfo && merchantInfo.business_name ? merchantInfo.business_name.charAt(0).toUpperCase() : "☕"}
//           </div>
//         </div>

//         {/* INTERFACE GRID SPLIT */}
//         <div className="main-grid">
          
//           {/* RULE CREATOR CARD */}
//           <div className="card">
//             <h2>Dynamic Rule Creator</h2>
//             <p>Configure automated multi-visit loyalty triggers for customers metrics.</p>

//             <div className="input-group">
//               <label>Target Visit Count</label>
//               <input
//                 type="number"
//                 placeholder="e.g. 5"
//                 value={visitNumber}
//                 onChange={(e) => setVisitNumber(e.target.value)}
//                 disabled={!subscription.active}
//               />
//             </div>

//             <div className="input-group">
//               <label>Reward Parameters</label>
//               <input
//                 type="text"
//                 placeholder="e.g. 15% Off Total Bill"
//                 value={reward}
//                 onChange={(e) => setReward(e.target.value)}
//                 disabled={!subscription.active}
//               />
//             </div>

//             <button 
//               className="save-btn" 
//               onClick={addRule}
//               disabled={!subscription.active}
//               style={!subscription.active ? { opacity: 0.5, cursor: "not-allowed", background: "#cbd5e1" } : {}}
//             >
//               {editingId ? "Modify Loyalty Ruleset 🔄" : "Deploy Live Campaign ➕"}
//             </button>
//           </div>

//           {/* DYNAMIC DATATABLE */}
//           <div className="card">
//             <h2>Active Campaign Management</h2>
//             <p>Track, calibrate, or discard real-time checkout incentive campaigns.</p>

//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>S.No</th>
//                     <th>Campaign Title</th>
//                     <th>Visits Required</th>
//                     <th>Reward Pipeline</th>
//                     <th>State</th>
//                     <th>Control Panel</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rules && rules.length > 0 ? (
//                     rules.map((item, index) => (
//                       <tr key={item.id || index}>
//                         <td>{index + 1}</td>
//                         <td>{item.title || `Visit ${item.total_visits} Times`}</td>
//                         <td><strong>{item.total_visits ?? "0"}</strong> Visits</td>
//                         <td>{item.reward ? item.reward : <span style={{ color: "#94a3b8" }}>-</span>}</td>
//                         <td>
//                           <span 
//                             className="badge" 
//                             style={{
//                               background: item.status === "active" ? "#dcfce7" : "#f1f5f9",
//                               color: item.status === "active" ? "#15803d" : "#475569"
//                             }}
//                           >
//                             {item.status ? item.status.toUpperCase() : "ACTIVE"}
                          
//                             {item.status ? item.status.toUpperCase() : "ACTIVE"}
//                           </span>
//                         </td>
//                         <td>
//                           <div className="actions">
//                             <button className="edit-btn" onClick={() => handleEditClick(item)} disabled={!subscription.active}>Edit</button>
//                             <button className="delete-btn" onClick={() => deleteRule(item.id)} disabled={!subscription.active}>Delete</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="6" style={{ textAlign: "center", padding: "40px", color: "#94a3b8" }}>
//                         No active metrics deployment cards found inside target account ruleset.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* GOOGLE LINK MANAGEMENT */}
//         <div className="google-box">
//           <h2>Google Review Link Integrator</h2>
//           <p>Sync your Google Map Business page reviews seamlessly to bootstrap reputation algorithms.</p>
//           <div className="google-input">
//             <input
//               type="text"
//               placeholder="https://g.page/r/your-business-profile/review"
//               value={googleLink}
//               onChange={(e) => setGoogleLink(e.target.value)}
//               disabled={!subscription.active}
//             />
//             <button 
//               className="google-save" 
//               onClick={saveGoogleLink}
//               disabled={!subscription.active}
//               style={!subscription.active ? { opacity: 0.6, cursor: "not-allowed", background: "#475569" } : {}}
//             >
//               Commit Changes
//             </button>
//           </div>
//         </div>

//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function MerchantLoyaltyRules() {
//   const navigate = useNavigate();
  
//   // State definitions
//   const [visitNumber, setVisitNumber] = useState("");
//   const [reward, setReward] = useState("");
//   const [googleLink, setGoogleLink] = useState("");
//   const [rules, setRules] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [merchantInfo, setMerchantInfo] = useState(null);
//   const [merchantId, setMerchantId] = useState("");
// const [rewardType, setRewardType] = useState("discount");
// const [discountType, setDiscountType] = useState("percentage");
// const [discountValue, setDiscountValue] = useState("");
// const [voucherValue, setVoucherValue] = useState("");
// const [minBillAmount, setMinBillAmount] = useState("");
//   // Subscription Status States
//   const [subscription, setSubscription] = useState({
//     active: false,
//     daysLeft: 0,
//     planName: "",
//     loaded: false
//   });

//   // ==========================================
//   // INITIALIZE DYNAMIC DATA FROM LOCALSTORAGE
//   // ==========================================
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
//         if (parsedData && parsedData.merchant) {
//           setMerchantInfo(parsedData.merchant);
//           setMerchantId(parsedData.merchant.user_id);
//           return;
//         }
//       }
//       console.warn("No merchant data found in localStorage. Redirecting to login.");
//     } catch (error) {
//       console.error("Error reading localStorage:", error);
//     }
//   }, [navigate]);

//   // Trigger API calls only when dynamic merchantId is set
//   useEffect(() => {
//     if (merchantId) {
//       checkSubscription();
//       fetchRules();
//       fetchMerchantDetails();
//     }
//   }, [merchantId]);

//   // ==========================================
//   // CHECK SUBSCRIPTION STATUS
//   // ==========================================
//   const checkSubscription = () => {
//     if (!merchantId) return;

//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

//     const urlencoded = new URLSearchParams();
//     urlencoded.append("merchant_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: urlencoded,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/check_subscription.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.subscription_active) {
//             setSubscription({
//               active: true,
//               daysLeft: parsedData.days_left,
//               planName: parsedData.plan_name,
//               loaded: true
//             });
//           } else {
//             setSubscription({
//               active: false,
//               daysLeft: 0,
//               planName: "",
//               loaded: true
//             });
//           }
//         } catch (e) {
//           console.error("Subscription parse error:", e);
//           setSubscription((prev) => ({ ...prev, loaded: true }));
//         }
//       })
//       .catch((error) => {
//         console.error("Error checking subscription:", error);
//         setSubscription((prev) => ({ ...prev, loaded: true }));
//       });
//   };

//   // ==========================================
//   // FETCH MERCHANT/RESTAURANT DETAILS DYNAMICALLY
//   // ==========================================
//   const fetchMerchantDetails = () => {
//     if (!merchantId) return;

//     const formdata = new FormData();
//     formdata.append("user_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`https://countmyvisit.com/Apis/getmarchantdashdetails.php?user_id=${merchantId}`, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.merchant) {
//             setMerchantInfo(parsedData.merchant);
//           }
//         } catch (e) {
//           console.error("Merchant info parse error:", e);
//         }
//       })
//       .catch((error) => console.error("Error fetching merchant details:", error));
//   };

//   // ==========================================
//   // FETCH ALL PASSES DYNAMICALLY
//   // ==========================================
//   // const fetchRules = () => {
//   //   if (!merchantId) return;

//   //   const formdata = new FormData();
//   //   formdata.append("merchant_id", merchantId);

//   //   const requestOptions = {
//   //     method: "POST",
//   //     body: formdata,
//   //     redirect: "follow"
//   //   };

//   //   fetch("https://countmyvisit.com/Apis/get_merchant_passes.php", requestOptions)
//   //     .then((response) => response.text())
//   //     .then((result) => {
//   //       try {
//   //         let cleanJsonString = result;
//   //         if (result.includes("DATABASE CONNECTED")) {
//   //           cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//   //         }

//   //         const parsedData = JSON.parse(cleanJsonString);
//   //         if (parsedData && parsedData.data && Array.isArray(parsedData.data)) {
//   //           setRules(parsedData.data);
//   //         } else if (Array.isArray(parsedData)) {
//   //           setRules(parsedData);
//   //         } else {
//   //           setRules([]);
//   //         }
//   //       } catch (e) {
//   //         console.error("Data parse error:", e);
//   //         setRules([]);
//   //       }
//   //     })
//   //     .catch((error) => {
//   //       console.error("API Error:", error);
//   //       setRules([]);
//   //     });
//   // };

//   const fetchRules = () => {
//   if (!merchantId) return;

//   const formdata = new FormData();
//   formdata.append("merchant_id", merchantId);

//   fetch("https://countmyvisit.com/Apis/get_merchant_passes.php", {
//     method: "POST",
//     body: formdata,
//   })
//     .then((res) => res.text())
//     .then((result) => {

//       let json = result.replace("DATABASE CONNECTED", "").trim();

//       const data = JSON.parse(json);

//       if (data.success) {
//         setSubscription({
//           active: true,
//           ...data.subscription,
//         });

//         setRules(data.rewards || []);
//       } else {
//         setRules([]);
//       }

//     })
//     .catch((err) => {
//       console.log(err);
//       setRules([]);
//     });
// };
//   // ==========================================
//   // ADD OR UPDATE PASS DYNAMICALLY
//   // ==========================================
//   // const addRule = () => {
//   //   if (!visitNumber || !reward) {
//   //     alert("Please fill all fields!");
//   //     return;
//   //   }
//   //   if (!merchantId) {
//   //     alert("Merchant Authentication missing. Please log in again.");
//   //     return;
//   //   }

//   //   if (editingId) {
//   //     const formdata = new FormData();
//   //     formdata.append("id", editingId);
//   //     formdata.append("title", `Visit ${visitNumber} Times`);
//   //     formdata.append("reward", reward);
//   //     formdata.append("total_visits", visitNumber);

//   //     const requestOptions = {
//   //       method: "POST",
//   //       body: formdata,
//   //       redirect: "follow",
//   //     };

//   //     fetch(`https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`, requestOptions)
//   //       .then((response) => response.text())
//   //       .then((result) => {
//   //         alert("Pass Updated Successfully! 🎉");
//   //         setEditingId(null);
//   //         setVisitNumber("");
//   //         setReward("");
//   //         fetchRules();
//   //       })
//   //       .catch((error) => console.error("Error editing pass:", error));

//   //   } else {
//   //     const formdata = new FormData();
//   //     formdata.append("merchant_id", merchantId);
//   //     formdata.append("title", `Visit ${visitNumber} Times`);
//   //     formdata.append("reward", reward);
//   //     formdata.append("total_visits", visitNumber);

//   //     const requestOptions = {
//   //       method: "POST",
//   //       body: formdata,
//   //       redirect: "follow",
//   //     };

//   //     fetch("https://countmyvisit.com/Apis/add_loyalty_pass.php", requestOptions)
//   //       .then((response) => response.text())
//   //       .then((result) => {
//   //         alert("New Pass Added Successfully! 🚀");
//   //         setVisitNumber("");
//   //         setReward("");
//   //         fetchRules();
//   //       })
//   //       .catch((error) => console.error("Error adding pass:", error));
//   //   }
//   // };
// const addRule = () => {

//   if (!visitNumber) {
//     alert("Enter Visit Count");
//     return;
//   }

//   if (!reward) {
//     alert("Enter Reward Name");
//     return;
//   }

//   if (!merchantId) {
//     alert("Merchant Login Expired");
//     return;
//   }

//   if (!minBillAmount) {
//     alert("Enter Minimum Bill Amount");
//     return;
//   }

//   if (rewardType === "discount" && !discountValue) {
//     alert("Enter Discount Value");
//     return;
//   }

//   if (rewardType === "voucher" && !voucherValue) {
//     alert("Enter Voucher Value");
//     return;
//   }

//   const formdata = new FormData();

//   formdata.append("merchant_id", merchantId);

//   formdata.append("title", `Visit ${visitNumber} Times`);

//   formdata.append("reward", reward);

//   formdata.append("total_visits", visitNumber);

//   formdata.append("min_bill_amount", minBillAmount);

//   formdata.append(
//     "voucher_value",
//     rewardType === "voucher"
//       ? voucherValue
//       : "0"
//   );

//   formdata.append(
//     "discount_value",
//     rewardType === "discount"
//       ? discountValue
//       : "0"
//   );

//   formdata.append(
//     "discount_type",
//     rewardType === "discount"
//       ? discountType
//       : ""
//   );

//   formdata.append(
//     "reward_type",
//     rewardType
//   );

//   const url = editingId
//     ? `https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`
//     : "https://countmyvisit.com/Apis/add_loyalty_pass.php";

//   if (editingId) {
//     formdata.append("id", editingId);
//   }

//   fetch(url, {
//     method: "POST",
//     body: formdata
//   })
//     .then(res => res.json())
//     .then(res => {

//       if (res.success) {

//         alert(editingId
//           ? "Rule Updated Successfully 🎉"
//           : "Rule Added Successfully 🚀"
//         );

//         setEditingId(null);

//         setVisitNumber("");

//         setReward("");

//         setDiscountValue("");

//         setVoucherValue("");

//         setMinBillAmount("");

//         setRewardType("discount");

//         setDiscountType("percentage");

//         fetchRules();

//       } else {

//         alert(res.message);

//       }

//     })
//     .catch(err => {

//       console.log(err);

//       alert("Server Error");

//     });

// };
//   const handleEditClick = (item) => {
//     setVisitNumber(item.total_visits || "");
//     setReward(item.reward || "");
//     setEditingId(item.id);
//   };

//   // ==========================================
//   // DELETE PASS
//   // ==========================================
//   const deleteRule = (id) => {
//     if (!window.confirm("Are you sure you want to delete this pass?")) return;

//     const formdata = new FormData();
//     formdata.append("id", String(id));

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/delete_loyalty_pass.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         alert("Pass Deleted Successfully!");
//         fetchRules();
//       })
//       .catch((error) => console.error("Error deleting pass:", error));
//   };

//   const saveGoogleLink = () => {
//     if (!googleLink) {
//       alert("Please enter a valid link first!");
//       return;
//     }
//     alert("Google Review Link Integrator Matrix Updated Successfully!");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("marchentdata");
//     navigate("/login");
//   };

//   const handleRenewSubscription = () => {
//     // Navigate to subscription payment page or trigger gateway
//     navigate("/MerchantSubs");
//   };

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; }
//         .merchant-page { min-height: 100vh; padding: 24px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); }
        
//         /* Subscription Alert Trackers */
//         .sub-status-bar { display: flex; justify-content: space-between; align-items: center; padding: 14px 24px; border-radius: 16px; margin-bottom: 24px; font-weight: 600; font-size: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.02); }
//         .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
//         .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
//         .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 13px; }
//         .sub-renew-btn { background: #ef4444; color: white; border: none; padding: 8px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 10px rgba(239, 68, 68, 0.2); }
//         .sub-renew-btn:hover { background: #dc2626; transform: translateY(-1px); }

//         /* Premium Dynamic Navigation Bar */
//         .premium-nav {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           background: #ffffff;
//           padding: 16px 32px;
//           border-radius: 20px;
//           box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05);
//           margin-bottom: 30px;
//           border: 1px solid rgba(255, 255, 255, 0.8);
//         }
//         .nav-logo-side { display: flex; align-items: center; gap: 14px; }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
//         .nav-actions { display: flex; gap: 12px; align-items: center; }
        
//         /* Nav Buttons */
//         .nav-btn {
//           padding: 10px 20px;
//           font-size: 14px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           border: none;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .btn-primary-nav { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.25); }
//         .btn-primary-nav:hover { opacity: 0.95; transform: translateY(-1px); }
//         .btn-secondary-nav { background: #f1f5f9; color: #475569; }
//         .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }
//         .btn-danger-nav { background: #fee2e2; color: #ef4444; }
//         .btn-danger-nav:hover { background: #fca5a5; color: #991b1b; }

//         /* Dashboard Top Info Card */
//         .top-header {
//           background: #ffffff;
//           padding: 30px;
//           border-radius: 24px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 30px;
//           border-left: 6px solid #ff8c42;
//         }
//         .merchant-title { font-size: 32px; font-weight: 800; color: #0f172a; text-transform: capitalize; }
//         .merchant-logo { width: 64px; height: 64px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 26px; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }
        
//         /* Grid Rules Layout */
//         .main-grid { display: grid; grid-template-columns: 400px 1fr; gap: 30px; }
//         .card { background: white; border-radius: 24px; padding: 32px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #f1f5f9; }
//         .card h2 { font-size: 24px; margin-bottom: 8px; color: #0f172a; font-weight: 700; }
//         .card p { color: #64748b; font-size: 14px; margin-bottom: 24px; }
        
//         /* Inputs Control styling */
//         .input-group { margin-bottom: 20px; }
//         .input-group label { display: block; margin-bottom: 8px; font-size: 13px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; }
//         .input-group input { width: 100%; height: 54px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 14px; padding: 0 16px; font-size: 15px; outline: none; transition: all 0.25s ease; }
//         .input-group input:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.15); }
        
//         .save-btn { width: 100%; height: 54px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); }
//         .save-btn:hover { transform: translateY(-2px); opacity: 0.95; }
        
//         /* Tables Core Engine */
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; }
//         table { width: 100%; border-collapse: collapse; min-width: 650px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 16px; font-size: 14px; font-weight: 700; border-bottom: 2px solid #e2e8f0; }
//         td { padding: 16px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
//         tr:hover { background: #f8fafc; }
        
//         /* Badges & Actions UI */
//         .badge { display: inline-block; padding: 6px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
//         .actions { display: flex; gap: 10px; }
//         .edit-btn { border: none; padding: 8px 14px; border-radius: 10px; background: #fff7ed; color: #ea580c; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .edit-btn:hover { background: #ffedd5; }
//         .delete-btn { border: none; padding: 8px 14px; border-radius: 10px; background: #fee2e2; color: #ef4444; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .delete-btn:hover { background: #fca5a5; color: #991b1b; }
        
//         /* Google Integrator section */
//         .google-box { margin-top: 30px; background: linear-gradient(135deg, #0f172a, #1e293b); border-radius: 24px; padding: 32px; color: white; }
//         .google-box h2 { color: white; }
//         .google-box p { color: #94a3b8; }
//         .google-input { display: flex; gap: 12px; flex-wrap: wrap; }
//         .google-input input { flex: 1; min-width: 250px; height: 54px; border: 1px solid #334155; background: rgba(255,255,255,0.05); border-radius: 14px; padding: 0 16px; font-size: 15px; color: white; outline: none; }
//         .google-input input:focus { border-color: #ff8c42; background: rgba(255,255,255,0.08); }
//         .google-save { padding: 0 28px; border: none; border-radius: 14px; background: #ff8c42; color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .google-save:hover { background: #f97316; transform: translateY(-1px); }

//         @media(max-width: 1100px){ .main-grid { grid-template-columns: 1fr; } }
//         @media(max-width: 768px){ .premium-nav { padding: 16px; flex-direction: column; gap: 16px; text-align: center; } }
//       `}</style>

//       <div className="merchant-page">
        
//         {/* NEW ADVANCED PRO NAVIGATION BAR */}
//         <nav className="premium-nav">
//           <div className="nav-logo-side">
//             <span style={{ fontSize: "24px" }}>📊</span>
//             <span className="nav-brand">Count My Visit Workspace</span>
//           </div>
//           <div className="nav-actions">
//             <button className="nav-btn btn-secondary-nav" onClick={() => { fetchRules(); checkSubscription(); }}>
//               🔄 Refresh Data
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantQRScreen")}>
//               📱 Download QR Code
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/merchantanalytics")}>
//               Merchant Feedback 
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantSubs")}>
//               Renew 
//             </button>
//              <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScanner")}>
//               SCAN QR
//             </button>
//               <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScanner")}>
//               SCAN QR radeem
//             </button>
//             <button className="nav-btn btn-danger-nav" onClick={handleLogout}>
//               🚪 Logout
//             </button>
//           </div>
//         </nav>

//         {/* DYNAMIC SUBSCRIPTION ALERTS PANEL */}
//         {subscription.loaded && (
//           subscription.active ? (
//             <div className="sub-status-bar sub-active-bar">
//               <span>Verified Account ✔️ Plan: {subscription.planName}</span>
//               <span className="sub-days-count">⏳ {subscription.daysLeft} Days Left</span>
//             </div>
//           ) : (
//             <div className="sub-status-bar sub-expired-bar">
//               <span>⚠️ No Active Subscription Found! Please renew to keep metrics campaigns operational.</span>
//               <button className="sub-renew-btn" onClick={handleRenewSubscription}>⚡ Renew Subscription</button>
//             </div>
//           )
//         )}

//         {/* RESTAURANT PROFILE HEADER (DYNAMICALLY RENDERED) */}
//         <div className="top-header">
//           <div>
//             {merchantInfo ? (
//               <>
//                 <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
//                   <h1 className="merchant-title">{merchantInfo.business_name || "Workspace"}</h1>
//                   <span className="badge" style={{ background: "#e0f2fe", color: "#0369a1" }}>
//                     {merchantInfo.business_type || "Merchant"}
//                   </span>
//                 </div>
//                 <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
//                   Welcome back, <strong style={{ color: "#0f172a" }}>{merchantInfo.owner_name}</strong> | 📍 {merchantInfo.address || "Location Active"}
//                 </p>
//               </>
//             ) : (
//               <>
//                 <h1 style={{ fontSize: "28px", fontWeight: "800", color: "#0f172a" }}>Loading Real-time Configuration...</h1>
//                 <p style={{ color: "#64748b", fontSize: "14px" }}>Synchronizing backend workspace keys safely.</p>
//               </>
//             )}
//           </div>
//           <div className="merchant-logo">
//             {merchantInfo && merchantInfo.business_name ? merchantInfo.business_name.charAt(0).toUpperCase() : "☕"}
//           </div>
//         </div>

//         {/* INTERFACE GRID SPLIT */}
//         <div className="main-grid">
//           <div className="main-grid">

//   {/* RULE CREATOR CARD */}

//   <div className="card">

//     <h2>🎁 Loyalty Reward Creator</h2>

//     <p>
//       Create smart loyalty rewards based on customer visit count and bill amount.
//     </p>

//     {/* Visit */}

//     <div className="input-group">
//       <label>Target Visit Count</label>

//       <input
//         type="number"
//         placeholder="e.g. 4"
//         value={visitNumber}
//         onChange={(e) => setVisitNumber(e.target.value)}
//         disabled={!subscription.active}
//       />
//     </div>

//     {/* Reward Title */}

//     <div className="input-group">
//       <label>Reward Title</label>

//       <input
//         type="text"
//         placeholder="Free Coffee / 20% Discount"
//         value={reward}
//         onChange={(e) => setReward(e.target.value)}
//         disabled={!subscription.active}
//       />
//     </div>

//     {/* Reward Type */}

//     <div className="input-group">
//       <label>Reward Type</label>

//       <select
//         value={rewardType}
//         onChange={(e) => setRewardType(e.target.value)}
//         disabled={!subscription.active}
//       >
//         <option value="discount">
//           💸 Discount
//         </option>

//         <option value="voucher">
//           🎁 Voucher
//         </option>

//       </select>
//     </div>

//     {/* Bill Amount */}

//     <div className="input-group">
//       <label>Minimum Bill Amount (₹)</label>

//       <input
//         type="number"
//         placeholder="2000"
//         value={minBillAmount}
//         onChange={(e) => setMinBillAmount(e.target.value)}
//         disabled={!subscription.active}
//       />
//     </div>

//     {/* Discount */}

//     {rewardType === "discount" && (

//       <>

//         <div className="input-group">

//           <label>Discount Type</label>

//           <select
//             value={discountType}
//             onChange={(e) => setDiscountType(e.target.value)}
//             disabled={!subscription.active}
//           >

//             <option value="percentage">
//               Percentage (%)
//             </option>

//             <option value="flat">
//               Flat Amount (₹)
//             </option>

//           </select>

//         </div>

//         <div className="input-group">

//           <label>

//             {discountType === "percentage"
//               ? "Discount Percentage (%)"
//               : "Flat Discount Amount"}

//           </label>

//           <input
//             type="number"
//             placeholder={
//               discountType === "percentage"
//                 ? "20"
//                 : "500"
//             }
//             value={discountValue}
//             onChange={(e) => setDiscountValue(e.target.value)}
//             disabled={!subscription.active}
//           />

//         </div>

//       </>

//     )}

//     {/* Voucher */}

//     {rewardType === "voucher" && (

//       <>

//         <div className="input-group">

//           <label>Voucher Value (₹)</label>

//           <input
//             type="number"
//             placeholder="250"
//             value={voucherValue}
//             onChange={(e) => setVoucherValue(e.target.value)}
//             disabled={!subscription.active}
//           />

//         </div>

//       </>

//     )}

//     <button
//       className="save-btn"
//       onClick={addRule}
//       disabled={!subscription.active}
//       style={
//         !subscription.active
//           ? {
//               opacity: 0.5,
//               cursor: "not-allowed",
//               background: "#cbd5e1"
//             }
//           : {}
//       }
//     >
//       {editingId
//         ? "✏️ Update Loyalty Reward"
//         : "🚀 Create Loyalty Reward"}
//     </button>

//   </div>

// </div>

//           {/* DYNAMIC DATATABLE */}
//           <div className="card">
//             <h2>Active Campaign Management</h2>
//             <p>Track, calibrate, or discard real-time checkout incentive campaigns.</p>

//             <div className="table-container">
//               <table>
//               <tbody>
//   {rules.length > 0 ? (
//     rules.map((item, index) => (
//       <tr key={item.id}>

//         <td>{index + 1}</td>

//         <td>{item.title}</td>

//         <td>
//           {item.visit_required} Visits
//         </td>

//         <td>

//           <div style={{fontWeight:"600"}}>
//             {item.reward}
//           </div>

//           <div style={{fontSize:12,color:"#64748b",marginTop:4}}>

//             Type :
//             {" "}
//             <strong>{item.reward_type}</strong>

//             {item.reward_type === "discount" && (
//               <>
//                 <br/>

//                 Bill :
//                 {" "}
//                 ₹{item.minimum_bill_amount}

//                 <br/>

//                 Discount :
//                 {" "}

//                 {item.discount_type==="percentage"
//                   ? `${item.discount_value}%`
//                   : `₹${item.discount_value}`
//                 }
//               </>
//             )}

//             {item.reward_type==="voucher" && (
//               <>
//                 <br/>

//                 Bill :
//                 {" "}
//                 ₹{item.minimum_bill_amount}

//                 <br/>

//                 Voucher :
//                 {" "}
//                 ₹{item.voucher_value}
//               </>
//             )}

//           </div>

//         </td>

//         <td>

//           <span
//             className="badge"
//             style={{
//               background:
//                 item.status==="active"
//                   ? "#dcfce7"
//                   : "#fee2e2",

//               color:
//                 item.status==="active"
//                   ? "#15803d"
//                   : "#dc2626"
//             }}
//           >
//             {item.status.toUpperCase()}
//           </span>

//         </td>

//         <td>

//           <div className="actions">

//             <button
//               className="edit-btn"
//               onClick={()=>handleEditClick(item)}
//             >
//               Edit
//             </button>

//             <button
//               className="delete-btn"
//               onClick={()=>deleteRule(item.id)}
//             >
//               Delete
//             </button>

//           </div>

//         </td>

//       </tr>
//     ))
//   ) : (
//     <tr>
//       <td
//         colSpan="6"
//         style={{
//           textAlign:"center",
//           padding:40
//         }}
//       >
//         No Rewards Found
//       </td>
//     </tr>
//   )}
// </tbody>
//               </table>
//             </div>
//           </div>
//         </div>

//         {/* GOOGLE LINK MANAGEMENT */}
//         <div className="google-box">
//           <h2>Google Review Link Integrator</h2>
//           <p>Sync your Google Map Business page reviews seamlessly to bootstrap reputation algorithms.</p>
//           <div className="google-input">
//             <input
//               type="text"
//               placeholder="https://g.page/r/your-business-profile/review"
//               value={googleLink}
//               onChange={(e) => setGoogleLink(e.target.value)}
//               disabled={!subscription.active}
//             />
//             <button 
//               className="google-save" 
//               onClick={saveGoogleLink}
//               disabled={!subscription.active}
//               style={!subscription.active ? { opacity: 0.6, cursor: "not-allowed", background: "#475569" } : {}}
//             >
//               Commit Changes
//             </button>
//           </div>
//         </div>

//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function MerchantLoyaltyRules() {
//   const navigate = useNavigate();
  
//   // State definitions
//   const [visitNumber, setVisitNumber] = useState("");
//   const [reward, setReward] = useState("");
//   const [googleLink, setGoogleLink] = useState("");
//   const [rules, setRules] = useState([]);
//   const [editingId, setEditingId] = useState(null);
//   const [merchantInfo, setMerchantInfo] = useState(null);
//   const [merchantId, setMerchantId] = useState("");
//   const [rewardType, setRewardType] = useState("discount");
//   const [discountType, setDiscountType] = useState("percentage");
//   const [discountValue, setDiscountValue] = useState("");
//   const [voucherValue, setVoucherValue] = useState("");
//   const [minBillAmount, setMinBillAmount] = useState("");
// const [googleReviewLink, setGoogleReviewLink] = useState("");
// const [savedReview, setSavedReview] = useState(null);
// const [loadingReview, setLoadingReview] = useState(true);
//   // Subscription Status States
//   const [subscription, setSubscription] = useState({
//     active: false,
//     daysLeft: 0,
//     planName: "",
//     loaded: false
//   });

//   // ==========================================
//   // INITIALIZE DYNAMIC DATA FROM LOCALSTORAGE
//   // ==========================================
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
//         if (parsedData && parsedData.merchant) {
//           setMerchantInfo(parsedData.merchant);
//           setMerchantId(parsedData.merchant.user_id);
//           return;
//         }
//       }
//       console.warn("No merchant data found in localStorage. Redirecting to login.");
//     } catch (error) {
//       console.error("Error reading localStorage:", error);
//     }
//   }, [navigate]);

//   // Trigger API calls only when dynamic merchantId is set
//   useEffect(() => {
//     if (merchantId) {
//       checkSubscription();
//       fetchRules();
//       fetchMerchantDetails();
//     }
//   }, [merchantId]);

//   // ==========================================
//   // CHECK SUBSCRIPTION STATUS
//   // ==========================================
//   const checkSubscription = () => {
//     if (!merchantId) return;

//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

//     const urlencoded = new URLSearchParams();
//     urlencoded.append("merchant_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: urlencoded,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/check_subscription.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.subscription_active) {
//             setSubscription({
//               active: true,
//               daysLeft: parsedData.days_left,
//               planName: parsedData.plan_name,
//               loaded: true
//             });
//           } else {
//             setSubscription({
//               active: false,
//               daysLeft: 0,
//               planName: "",
//               loaded: true
//             });
//           }
//         } catch (e) {
//           console.error("Subscription parse error:", e);
//           setSubscription((prev) => ({ ...prev, loaded: true }));
//         }
//       })
//       .catch((error) => {
//         console.error("Error checking subscription:", error);
//         setSubscription((prev) => ({ ...prev, loaded: true }));
//       });
//   };
// const fetchGoogleReview = () => {

//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");

//     const raw = JSON.stringify({
//         merchant_id: merchantId
//     });

//     fetch("https://countmyvisit.com/Apis/get_google_review.php", {
//         method: "POST",
//         headers: myHeaders,
//         body: raw
//     })
//     .then(res => res.json())
//     .then(result => {

//         if(result.success){

//             setSavedReview(result.data);

//             setGoogleReviewLink(result.data.google_review_link);

//         }else{

//             setSavedReview(null);

//             setGoogleReviewLink("");

//         }

//         setLoadingReview(false);

//     })
//     .catch(err=>{

//         console.log(err);

//         setSavedReview(null);

//         setLoadingReview(false);

//     });

// }
// const saveGoogleReview = () => {

//     if(!googleReviewLink){

//         alert("Please Enter Google Review Link");

//         return;

//     }

//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type","application/json");

//     const raw = JSON.stringify({

//         merchant_id:merchantId,

//         google_review_link:googleReviewLink

//     });

//     fetch("https://countmyvisit.com/Apis/save_google_review.php",{

//         method:"POST",

//         headers:myHeaders,

//         body:raw

//     })

//     .then(res=>res.json())

//     .then(result=>{

//         if(result.success){

//             alert(result.message);

//             fetchGoogleReview();

//         }else{

//             alert(result.message);

//         }

//     });

// }
// const deleteGoogleReview = () => {

//     if(!window.confirm("Delete Google Review Link?"))
//         return;

//     const myHeaders = new Headers();

//     myHeaders.append("Content-Type","application/json");

//     const raw = JSON.stringify({

//         merchant_id:merchantId

//     });

//     fetch("https://countmyvisit.com/Apis/delete_google_review.php",{

//         method:"POST",

//         headers:myHeaders,

//         body:raw

//     })

//     .then(res=>res.json())

//     .then(result=>{

//         alert(result.message);

//         if(result.success){

//             setSavedReview(null);

//             setGoogleReviewLink("");

//         }

//     });

// }
// useEffect(()=>{

//     if(merchantId){

//         fetchGoogleReview();

//     }

// },[merchantId]);
//   // ==========================================
//   // FETCH MERCHANT DETAILS
//   // ==========================================
//   const fetchMerchantDetails = () => {
//     if (!merchantId) return;

//     const formdata = new FormData();
//     formdata.append("user_id", merchantId);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch(`https://countmyvisit.com/Apis/getmarchantdashdetails.php?user_id=${merchantId}`, requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         try {
//           let cleanJsonString = result;
//           if (result.includes("DATABASE CONNECTED")) {
//             cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//           }

//           const parsedData = JSON.parse(cleanJsonString);
//           if (parsedData.success && parsedData.merchant) {
//             setMerchantInfo(parsedData.merchant);
//           }
//         } catch (e) {
//           console.error("Merchant info parse error:", e);
//         }
//       })
//       .catch((error) => console.error("Error fetching merchant details:", error));
//   };

//   // ==========================================
//   // FETCH ALL PASSES DYNAMICALLY
//   // ==========================================
//   const fetchRules = () => {
//     if (!merchantId) return;

//     const formdata = new FormData();
//     formdata.append("merchant_id", merchantId);

//     fetch("https://countmyvisit.com/Apis/get_merchant_passes.php", {
//       method: "POST",
//       body: formdata,
//     })
//       .then((res) => res.text())
//       .then((result) => {
//         let json = result.replace("DATABASE CONNECTED", "").trim();
//         const data = JSON.parse(json);

//         if (data.success) {
//           setSubscription({
//             active: true,
//             ...data.subscription,
//             loaded: true
//           });
//           setRules(data.rewards || []);
//         } else {
//           setRules([]);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//         setRules([]);
//       });
//   };

//   // ==========================================
//   // ADD OR UPDATE PASS DYNAMICALLY
//   // ==========================================
//   const addRule = () => {
//     if (!visitNumber) return alert("Enter Visit Count");
//     if (!reward) return alert("Enter Reward Name");
//     if (!merchantId) return alert("Merchant Login Expired");
//     if (!minBillAmount) return alert("Enter Minimum Bill Amount");
//     if (rewardType === "discount" && !discountValue) return alert("Enter Discount Value");
//     if (rewardType === "voucher" && !voucherValue) return alert("Enter Voucher Value");

//     const formdata = new FormData();
//     formdata.append("merchant_id", merchantId);
//     formdata.append("title", `Visit ${visitNumber} Times`);
//     formdata.append("reward", reward);
//     formdata.append("total_visits", visitNumber);
//     formdata.append("min_bill_amount", minBillAmount);
//     formdata.append("voucher_value", rewardType === "voucher" ? voucherValue : "0");
//     formdata.append("discount_value", rewardType === "discount" ? discountValue : "0");
//     formdata.append("discount_type", rewardType === "discount" ? discountType : "");
//     formdata.append("reward_type", rewardType);

//     const url = editingId
//       ? `https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`
//       : "https://countmyvisit.com/Apis/add_loyalty_pass.php";

//     if (editingId) {
//       formdata.append("id", editingId);
//     }

//     // 🌟 Parsing text first to remove backend raw text prints if any
//     fetch(url, {
//       method: "POST",
//       body: formdata
//     })
//       .then(res => res.text())
//       .then(result => {
//         let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//         const res = JSON.parse(cleanJsonString);

//         if (res.success) {
//           alert(editingId ? "Rule Updated Successfully 🎉" : "Rule Added Successfully 🚀");
          
//           // Clear form states safely
//           setEditingId(null);
//           setVisitNumber("");
//           setReward("");
//           setDiscountValue("");
//           setVoucherValue("");
//           setMinBillAmount("");
//           setRewardType("discount");
//           setDiscountType("percentage");
          
//           fetchRules();
//         } else {
//           alert(res.message || "Operation failed on server validation");
//         }
//       })
//       .catch(err => {
//         console.log("Submission Error Log:", err);
//         alert("Server responded with parsing mismatch. Reloading rules matrix.");
//         fetchRules();
//       });
//   };

//   // ==========================================
//   // SYNC COMPLETE MAP ON EDIT
//   // ==========================================
//   const handleEditClick = (item) => {
//     setEditingId(item.id);
//     setVisitNumber(item.visit_required || item.total_visits || "");
//     setReward(item.reward || "");
//     setRewardType(item.reward_type || "discount");
//     setMinBillAmount(item.minimum_bill_amount || "");
//     setDiscountType(item.discount_type || "percentage");
//     setDiscountValue(item.discount_value || "");
//     setVoucherValue(item.voucher_value || "");
    
//     // Scroll window smoothly up into context inputs view layout
//     window.scrollTo({ top: 300, behavior: 'smooth' });
//   };

//   // ==========================================
//   // DELETE PASS
//   // ==========================================
//   const deleteRule = (id) => {
//     if (!window.confirm("Are you sure you want to delete this pass?")) return;

//     const formdata = new FormData();
//     formdata.append("id", String(id));

//     fetch("https://countmyvisit.com/Apis/delete_loyalty_pass.php", {
//       method: "POST",
//       body: formdata
//     })
//       .then((res) => res.text())
//       .then((result) => {
//         alert("Pass Deleted Successfully!");
//         fetchRules();
//       })
//       .catch((error) => console.error("Error deleting pass:", error));
//   };

//   const saveGoogleLink = () => {
//     if (!googleLink) return alert("Please enter a valid link first!");
//     alert("Google Review Link Integrator Matrix Updated Successfully!");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("marchentdata");
//     navigate("/login");
//   };

//   return (
//     <>
//  <style>{`
//   /* --- Base Reset & Core Setup --- */
//   * { 
//     margin: 0; 
//     padding: 0; 
//     box-sizing: border-box; 
//     font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; 
//   }
//   body { 
//     background: #f8fafc; 
//     color: #1e293b; 
//     -webkit-font-smoothing: antialiased;
//     -moz-osx-font-smoothing: grayscale;
//   }
//   .merchant-page { 
//     min-height: 100vh; 
//     padding: 12px; 
//     background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); 
//   }
  
//   /* --- Premium Dynamic Navigation Bar --- */
//   .premium-nav {
//     display: flex;
//     flex-direction: column;
//     gap: 16px;
//     background: #ffffff;
//     padding: 16px;
//     border-radius: 16px;
//     box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05);
//     margin-bottom: 20px;
//     border: 1px solid rgba(255, 255, 255, 0.8);
//   }
//   .nav-logo-side { 
//     display: flex; 
//     align-items: center; 
//     gap: 14px; 
//     width: 100%;
//     justify-content: center;
//   }
//   .nav-brand { 
//     font-size: 18px; 
//     font-weight: 800; 
//     background: linear-gradient(135deg, #ff8c42, #ff5e62); 
//     -webkit-background-clip: text; 
//     -webkit-text-fill-color: transparent; 
//   }
//   .nav-actions { 
//     display: flex; 
//     gap: 8px; 
//     align-items: center; 
//     flex-wrap: wrap; 
//     justify-content: center;
//     width: 100%;
//   }
  
//   /* --- Nav Buttons Style Engine --- */
//   .nav-btn {
//     padding: 10px 14px;
//     font-size: 12px;
//     font-weight: 600;
//     border-radius: 10px;
//     cursor: pointer;
//     transition: all 0.2s ease;
//     border: none;
//     display: flex;
//     align-items: center;
//     gap: 6px;
//     flex: 1 1 calc(50% - 8px); /* 2 items per row on narrow screens */
//     justify-content: center;
//     min-width: 120px;
//   }
//   .btn-primary-nav { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.25); }
//   .btn-primary-nav:hover { opacity: 0.95; transform: translateY(-1px); }
//   .btn-secondary-nav { background: #f1f5f9; color: #475569; }
//   .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }
//   .btn-danger-nav { background: #fee2e2; color: #ef4444; }
//   .btn-danger-nav:hover { background: #fca5a5; color: #991b1b; }

//   /* --- Subscription Trackers --- */
//   .sub-status-bar { 
//     display: flex; 
//     flex-direction: column;
//     gap: 12px;
//     align-items: center; 
//     text-align: center;
//     padding: 16px; 
//     border-radius: 14px; 
//     margin-bottom: 20px; 
//     font-weight: 600; 
//     font-size: 14px; 
//   }
//   .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
//   .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
//   .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 12px; }
//   .sub-renew-btn { width: 100%; max-width: 200px; background: #ef4444; color: white; border: none; padding: 10px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; box-shadow: 0 4px 10px rgba(239, 68, 68, 0.2); }

//   /* --- Top Header Card --- */
//   .top-header {
//     background: #ffffff;
//     padding: 16px;
//     border-radius: 16px;
//     box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//     display: flex;
//     flex-direction: column-reverse;
//     gap: 16px;
//     align-items: center;
//     text-align: center;
//     margin-bottom: 20px;
//     border-left: 6px solid #ff8c42;
//   }
//   .merchant-title { font-size: 22px; font-weight: 800; color: #0f172a; text-transform: capitalize; }
//   .merchant-logo { width: 48px; height: 48px; border-radius: 12px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 18px; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }

//   /* --- Structural Modern Layout Splits (Responsive Grid System) --- */
//   .main-grid { 
//     display: grid; 
//     grid-template-columns: 1fr; /* Stacks nicely on Mobile */
//     gap: 20px; 
//     align-items: start; 
//   }
  
//   /* Flexible container cards (Works for both Create Side and Show Side) */
//   .card { 
//     background: white; 
//     border-radius: 16px; 
//     padding: 20px; 
//     box-shadow: 0 10px 25px rgba(15, 23, 42, 0.03); 
//     border: 1px solid #e2e8f0; 
//     height: auto; 
//     width: 100%;
//   }
//   .card h2 { font-size: 18px; margin-bottom: 6px; color: #0f172a; font-weight: 700; }
//   .card p { color: #64748b; font-size: 13px; margin-bottom: 16px; line-height: 1.5; }

//   /* --- Inputs Engine styling (Loyalty Pass Creation Area) --- */
//   .input-group { margin-bottom: 14px; text-align: left; }
//   .input-group label { display: block; margin-bottom: 6px; font-size: 11px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; }
//   .input-group input, .input-group select, .input-group textarea { 
//     width: 100%; 
//     height: 44px; 
//     border: 1px solid #cbd5e1; 
//     background: #f8fafc; 
//     border-radius: 10px; 
//     padding: 0 12px; 
//     font-size: 14px; 
//     outline: none; 
//     transition: all 0.2s ease; 
//     color: #334155; 
//   }
//   .input-group textarea { height: auto; padding: 10px 12px; }
//   .input-group input:focus, .input-group select:focus, .input-group textarea:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 3px rgba(255,140,66,0.12); }
  
//   .save-btn { width: 100%; height: 46px; border: none; border-radius: 10px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); }
//   .save-btn:hover { transform: translateY(-1px); opacity: 0.95; }

//   /* --- Table Responsive Wrapper Box (Loyalty Pass Show Area) --- */
//   .table-scroll-container { 
//     max-height: 540px; 
//     overflow-x: auto; /* Handles horizontal scroll perfectly on tiny mobile widths */
//     overflow-y: auto; 
//     border-radius: 12px; 
//     border: 1px solid #e2e8f0;
//     box-shadow: inset 0 2px 8px rgba(0,0,0,0.02);
//     background: #ffffff;
//     -webkit-overflow-scrolling: touch;
//     width: 100%;
//   }
  
//   /* --- Table Architecture UI --- */
//   table { width: 100%; border-collapse: collapse; text-align: left; }
//   th { background: #f8fafc; color: #475569; padding: 12px 14px; font-size: 12px; font-weight: 700; border-bottom: 2px solid #e2e8f0; position: sticky; top: 0; z-index: 10; white-space: nowrap; }
//   td { padding: 12px 14px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 13px; vertical-align: middle; white-space: nowrap; }
//   tr:hover { background: #f8fafc; }

//   .badge { display: inline-block; padding: 4px 8px; border-radius: 10px; font-size: 10px; font-weight: 700; text-transform: uppercase; }
//   .actions { display: flex; gap: 6px; flex-wrap: wrap; }
//   .edit-btn { border: none; padding: 6px 10px; border-radius: 6px; background: #fff7ed; color: #ea580c; font-weight: 600; cursor: pointer; font-size: 12px; }
//   .edit-btn:hover { background: #ffedd5; }
//   .delete-btn { border: none; padding: 6px 10px; border-radius: 6px; background: #fee2e2; color: #ef4444; font-weight: 600; cursor: pointer; font-size: 12px; }
//   .delete-btn:hover { background: #fca5a5; }

//   /* --- Google Box --- */
//   .google-box { margin-top: 20px; background: linear-gradient(135deg, #0f172a, #1e293b); border-radius: 16px; padding: 20px; color: white; width: 100%; }
//   .google-box h2 { color: white; font-size: 18px; }
//   .google-box p { color: #94a3b8; font-size: 13px; }
//   .google-input { display: flex; flex-direction: column; gap: 10px; margin-top: 14px; }
//   .google-input input { width: 100%; height: 44px; border: 1px solid #334155; background: rgba(255,255,255,0.05); border-radius: 10px; padding: 0 12px; font-size: 14px; color: white; outline: none; }
//   .google-save { width: 100%; height: 44px; border: none; border-radius: 10px; background: #ff8c42; color: white; font-size: 14px; font-weight: 600; cursor: pointer; }

//   /* ==========================================================================
//      MEDIA QUERIES (Adapts beautifully upwards to Tablet & Large Monitors)
//      ========================================================================== */

//   /* --- Tablets (640px and up) --- */
//   @media (min-width: 640px) {
//     .merchant-page { padding: 20px; }
//     .premium-nav { padding: 16px 24px; flex-direction: row; justify-content: space-between; }
//     .nav-logo-side { width: auto; justify-content: flex-start; }
//     .nav-actions { width: auto; justify-content: flex-end; }
//     .nav-btn { flex: initial; }
    
//     .sub-status-bar { flex-direction: row; justify-content: space-between; text-align: left; }
//     .sub-renew-btn { width: auto; }

//     .top-header { flex-direction: row; justify-content: space-between; text-align: left; padding: 20px 24px; }
    
//     .google-input { flex-direction: row; }
//     .google-save { width: auto; }
//   }

//   /* --- Desktop Monitors (1024px and up) --- */
//   @media (min-width: 1024px) {
//     .merchant-page { padding: 24px; }
//     .premium-nav { padding: 16px 32px; border-radius: 20px; margin-bottom: 30px; }
//     .nav-brand { font-size: 20px; }
//     .top-header { padding: 24px 30px; border-radius: 24px; margin-bottom: 30px; }
//     .merchant-title { font-size: 28px; }
//     .merchant-logo { width: 56px; height: 56px; border-radius: 16px; font-size: 22px; }

//     /* Forms on Left (400px fixed width) & Live Loyalty Pass Table Display on Right (Fills up remainder) */
//     .main-grid { grid-template-columns: 400px 1fr; gap: 24px; }
//     .card { padding: 28px; border-radius: 24px; }
//     .card h2 { font-size: 20px; }
//     .google-box { padding: 28px; border-radius: 20px; }
//     .google-box h2 { font-size: 20px; }
//   }
// `}</style>

//       <div className="merchant-page">
        
//         {/* TOP MAIN NAVIGATION BAR */}
//         <nav className="premium-nav">
//           <div className="nav-logo-side">
//             <span style={{ fontSize: "22px" }}>📊</span>
//             <span className="nav-brand">Count My Visit Workspace</span>
//           </div>
//           <div className="nav-actions">
//             <button className="nav-btn btn-secondary-nav" onClick={() => { fetchRules(); checkSubscription(); }}>
//               🔄 Refresh Data
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantQRScreen")}>
//               📱 Download QR
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/merchantanalytics")}>
//               💬 Feedback
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantSubs")}>
//               ⚡ Renew
//             </button>
//             <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScannerScreen")}>
//               🔍 Add Visit by Scan
//             </button>
//                  <button className="nav-btn btn-primary-nav" onClick={() => navigate("/MerchantScanner")}>
//               🔍 Redeem voucher by scan
//             </button>
//             <button className="nav-btn btn-danger-nav" onClick={handleLogout}>
//               🚪 Logout
//             </button>
//           </div>
//         </nav>

//         {/* SUBSCRIPTION PANEL STATUS */}
//         {subscription.loaded && (
//           subscription.active ? (
//             <div className="sub-status-bar sub-active-bar">
//               <span>Verified Merchant Profile ✔️ Account Status: Active ({subscription.planName || "Premium"})</span>
//               <span className="sub-days-count">⏳ {subscription.daysLeft} Days Remaining</span>
//             </div>
//           ) : (
//             <div className="sub-status-bar sub-expired-bar">
//               <span>⚠️ Gateway Warning: Subscription Campaign Expired! Please renew to reactivate parameters mapping.</span>
//               <button className="sub-renew-btn" onClick={() => navigate("/MerchantSubs")}>⚡ Renew Platform</button>
//             </div>
//           )
//         )}

//         {/* WORKSPACE DETAILS HEADER */}
//         <div className="top-header">
//           <div>
//             {merchantInfo ? (
//               <>
//                 <div style={{ display: "flex", alignMocks: "center", gap: "10px", alignItems: "center" }}>
//                   <h1 className="merchant-title">{merchantInfo.business_name || "Merchant Business Workspace"}</h1>
//                   <span className="badge" style={{ background: "#e0f2fe", color: "#0369a1" }}>
//                     {merchantInfo.business_type || "Retailer Store"}
//                   </span>
//                 </div>
//                 <p style={{ color: "#64748b", fontSize: "13px", marginTop: "4px" }}>
//                   Operator: <strong style={{ color: "#0f172a" }}>{merchantInfo.owner_name}</strong> | 📍 {merchantInfo.address || "Active Branch Network"}
//                 </p>
//               </>
//             ) : (
//               <>
//                 <h1 style={{ fontSize: "24px", fontWeight: "800", color: "#0f172a" }}>Syncing Core Workspace Controls...</h1>
//                 <p style={{ color: "#64748b", fontSize: "13px" }}>Connecting securely to remote relational schemas data models.</p>
//               </>
//             )}
//           </div>
//           <div className="merchant-logo">
//             {merchantInfo?.business_name ? merchantInfo.business_name.charAt(0).toUpperCase() : "🏪"}
//           </div>
//         </div>

//         {/* INTERFACE GRID ENGINE SPLIT */}
//         <div className="main-grid">
          
//           {/* CONTROL SCHEMAS CREATOR COLUMN */}
//           <div className="card">
//             <h2>{editingId ? "✏️ Edit Loyalty Campaign" : "🎁 Loyalty Reward Creator"}</h2>
//             <p>Define operational triggers for visitor counters and voucher thresholds below.</p>

//             <div className="input-group">
//               <label>Target Visit Count</label>
//               <input
//                 type="number"
//                 placeholder="e.g. 4"
//                 value={visitNumber}
//                 onChange={(e) => setVisitNumber(e.target.value)}
//                 disabled={!subscription.active}
//               />
//             </div>

//             <div className="input-group">
//               <label>Reward Title Line</label>
//               <input
//                 type="text"
//                 placeholder="e.g. Complimentary Beverage"
//                 value={reward}
//                 onChange={(e) => setReward(e.target.value)}
//                 disabled={!subscription.active}
//               />
//             </div>

//             <div className="input-group">
//               <label>Reward Strategy Type</label>
//               <select
//                 value={rewardType}
//                 onChange={(e) => setRewardType(e.target.value)}
//                 disabled={!subscription.active}
//               >
//                 <option value="discount">💸 Direct Invoice Discount</option>
//                 <option value="voucher">🎁 Redeemable Gift Voucher</option>
//               </select>
//             </div>

//             <div className="input-group">
//               <label>Minimum Required Bill Amount (₹)</label>
//               <input
//                 type="number"
//                 placeholder="e.g. 1500"
//                 value={minBillAmount}
//                 onChange={(e) => setMinBillAmount(e.target.value)}
//                 disabled={!subscription.active}
//               />
//             </div>

//             {rewardType === "discount" && (
//               <>
//                 <div className="input-group">
//                   <label>Discount Type Mode</label>
//                   <select
//                     value={discountType}
//                     onChange={(e) => setDiscountType(e.target.value)}
//                     disabled={!subscription.active}
//                   >
//                     <option value="percentage">Percentage Value (%)</option>
//                     <option value="flat">Flat Value Reduction (₹)</option>
//                   </select>
//                 </div>

//                 <div className="input-group">
//                   <label>{discountType === "percentage" ? "Value Allocation (%)" : "Flat Reduction Amount (₹)"}</label>
//                   <input
//                     type="number"
//                     placeholder={discountType === "percentage" ? "15" : "300"}
//                     value={discountValue}
//                     onChange={(e) => setDiscountValue(e.target.value)}
//                     disabled={!subscription.active}
//                   />
//                 </div>
//               </>
//             )}

//             {rewardType === "voucher" && (
//               <div className="input-group">
//                 <label>Voucher Face Value (₹)</label>
//                 <input
//                   type="number"
//                   placeholder="500"
//                   value={voucherValue}
//                   onChange={(e) => setVoucherValue(e.target.value)}
//                   disabled={!subscription.active}
//                 />
//               </div>
//             )}

//             <button
//               className="save-btn"
//               onClick={addRule}
//               disabled={!subscription.active}
//               style={!subscription.active ? { opacity: 0.5, cursor: "not-allowed", background: "#cbd5e1", boxShadow: "none" } : {}}
//             >
//               {editingId ? "⚡ Commit Strategy Changes" : "🚀 Deploy Loyalty Campaign"}
//             </button>
//           </div>

//           {/* DATATABLE DASHBOARD VISUALS (SCROLL ENCLOSED IN ARCHITECTURE VIEW) */}
//           <div className="card">
//             <h2>Active Campaign Infrastructure</h2>
//             <p>Live campaigns operating on checkout logs counters. Internal container scrolls dynamically.</p>

//             <div className="table-scroll-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Campaign ID</th>
//                     <th>Target Metric</th>
//                     <th>Benefits Array Details</th>
//                     <th>State</th>
//                     <th>Control Operations</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rules.length > 0 ? (
//                     rules.map((item, index) => (
//                       <tr key={item.id || index}>
//                         <td><strong>{index + 1}</strong></td>
//                         <td>{item.title || `Visit Pass #${item.id}`}</td>
//                         <td>
//                           <span className="badge" style={{ background: "#f1f5f9", color: "#334155" }}>
//                             🎯 {item.visit_required || item.total_visits} Visits
//                           </span>
//                         </td>
//                         <td>
//                           <div style={{ fontWeight: "700", color: "#0f172a" }}>{item.reward}</div>
//                           <div style={{ fontSize: "11px", color: "#64748b", marginTop: "4px", lineHeight: "1.4" }}>
//                             Type: <strong style={{ color: "#334155" }}>{item.reward_type?.toUpperCase()}</strong><br />
//                             Min Invoice Check: <strong>₹{item.minimum_bill_amount || 0}</strong>
//                             {item.reward_type === "discount" && (
//                               <>
//                                 <br />Value Metric: <strong>
//                                   {item.discount_type === "percentage" ? `${item.discount_value}% Off` : `₹${item.discount_value} Deducted`}
//                                 </strong>
//                               </>
//                             )}
//                             {item.reward_type === "voucher" && (
//                               <>
//                                 <br />Voucher Yield: <strong>₹{item.voucher_value || 0}</strong>
//                               </>
//                             )}
//                           </div>
//                         </td>
//                         <td>
//                           <span
//                             className="badge"
//                             style={{
//                               background: item.status === "active" ? "#dcfce7" : "#fee2e2",
//                               color: item.status === "active" ? "#15803d" : "#dc2626"
//                             }}
//                           >
//                             {item.status || "Active"}
//                           </span>
//                         </td>
//                         <td>
//                           <div className="actions">
//                             <button className="edit-btn" onClick={() => handleEditClick(item)}>✏️ Edit</button>
//                             <button className="delete-btn" onClick={() => deleteRule(item.id)}>🗑️ Remove</button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="6" style={{ textAlign: "center", padding: "60px 0", color: "#94a3b8", fontWeight: "500" }}>
//                         📭 No active structural loyalty passes found in this query.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//         </div>

//         {/* REPUTATION INTEGRATOR PLATFORM */}
      
// <div className="card">

//     <h2>Google Review Link</h2>

//     <p>
//         Customers will be redirected here after redeeming rewards.
//     </p>

//     {loadingReview ? (

//         <p>Loading...</p>

//     ) : savedReview ? (

//         <>

//             <div className="input-group">

//                 <label>Saved Google Review Link</label>

//                 <input

//                     value={savedReview.google_review_link}

//                     readOnly

//                 />

//             </div>

//             <button

//                 className="delete-btn"

//                 onClick={deleteGoogleReview}

//             >

//                 Delete Review Link

//             </button>

//         </>

//     ) : (

//         <>

//             <div className="input-group">

//                 <label>Google Review Link</label>

//                 <input

//                     type="text"

//                     placeholder="https://g.page/r/xxxx/review"

//                     value={googleReviewLink}

//                     onChange={(e)=>setGoogleReviewLink(e.target.value)}

//                 />

//             </div>

//             <button

//                 className="save-btn"

//                 onClick={saveGoogleReview}

//             >

//                 Save Google Review Link

//             </button>

//         </>

//     )}

// </div>
//       </div>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardNav from "./DashboardNav";
 
import LoyaltyForm from "../MerchentScreens/LoyaltyForm";

export default function MerchantLoyaltyRules() {
  const navigate = useNavigate();

  // State definitions
  const [visitNumber, setVisitNumber] = useState("");
  const [reward, setReward] = useState("");
  const [googleLink, setGoogleLink] = useState("");
  const [rules, setRules] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [merchantInfo, setMerchantInfo] = useState(null);
  const [merchantId, setMerchantId] = useState("");
  const [rewardType, setRewardType] = useState("discount");
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState("");
  const [voucherValue, setVoucherValue] = useState("");
  const [minBillAmount, setMinBillAmount] = useState("");
  const [googleReviewLink, setGoogleReviewLink] = useState("");
  const [savedReview, setSavedReview] = useState(null);
  const [loadingReview, setLoadingReview] = useState(true);
 
console.log('i am mechent account',merchantId)
 useEffect(() => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  if (isLoggedIn !== "true") {
    // replace: true lagane se back-button lock ho jayega!
    navigate("/", { replace: true });
  }
}, [navigate]);
  const [subscription, setSubscription] = useState({
    active: false,
    daysLeft: 0,
    planName: "",
    loaded: false
  });

  // Fetch Logic Hooks
  useEffect(() => {
    try {
      const savedDataString = localStorage.getItem("marchentdata");
      if (savedDataString) {
        const parsedData = JSON.parse(savedDataString);
        if (parsedData && parsedData.merchant) {
          setMerchantInfo(parsedData.merchant);
          setMerchantId(parsedData.merchant.user_id);
          return;
        }
      }
      console.warn("No merchant data found in localStorage. Redirecting to login.");
    } catch (error) {
      console.error("Error reading localStorage:", error);
    }
  }, [navigate]);

  useEffect(() => {
    if (merchantId) {
      checkSubscription();
      fetchRules();
      fetchMerchantDetails();
      fetchGoogleReview();
    }
  }, [merchantId]);

  /* =========================================================
     1. AUTHENTICATION & LOGIN CHECK (Direct Access Block)
  ========================================================= */
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const savedDataString = localStorage.getItem("marchentdata");

    if (!isLoggedIn || !savedDataString) {
      // Agar logged in nahi hai toh direct WelcomeGateway par bhej do
      navigate("/", { replace: true });
    }
  }, [navigate]);

  /* =========================================================
     2. BLOCK BACK BUTTON (Back Na Jane Dene Ke Liye)
  ========================================================= */
  useEffect(() => {
    // Current history state ko browser stack mein push karo
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Jab bhi user back press kare, fir se same page push kar do
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  /* =========================================================
     3. LOGOUT HANDLER (Bahar jane ka iklota rasta)
  ========================================================= */
  

  const checkSubscription = () => {
    if (!merchantId) return;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    const urlencoded = new URLSearchParams();
    urlencoded.append("merchant_id", merchantId);

    fetch("https://countmyvisit.com/Apis/check_subscription.php", {
      method: "POST",
      headers: myHeaders,
      body: urlencoded
    })
      .then((response) => response.text())
      .then((result) => {
        try {
          let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
          const parsedData = JSON.parse(cleanJsonString);
          if (parsedData.success && parsedData.subscription_active) {
            setSubscription({ active: true, daysLeft: parsedData.days_left, planName: parsedData.plan_name, loaded: true });
          } else {
            setSubscription({ active: false, daysLeft: 0, planName: "", loaded: true });
          }
        } catch (e) {
          console.error("Subscription parse error:", e);
          setSubscription((prev) => ({ ...prev, loaded: true }));
        }
      })
      .catch((error) => {
        console.error("Error checking subscription:", error);
        setSubscription((prev) => ({ ...prev, loaded: true }));
      });
  };
 const fetchGoogleReview = () => {
  if (!merchantId) {
    setLoadingReview(false);
    return;
  }

  // Fetch start hote hi loading tracker ko active karein
  setLoadingReview(true);

  // PHP compatible FormData container setup
  const formdata = new FormData();
  formdata.append("merchant_id", String(merchantId));

  fetch("https://countmyvisit.com/Apis/get_google_review.php", {
    method: "POST",
    body: formdata // JSON stringify ki jagah pure FormData framework send karein
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP network error! Status: ${res.status}`);
      }
      return res.text(); // Raw text read pipeline setup
    })
    .then((result) => {
      // 🌟 Database connection message strings ko filter out karein
      let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
      const parsedData = JSON.parse(cleanJsonString);

      if (parsedData.success && parsedData.data) {
        setSavedReview(parsedData.data);
        // Input state box ko pre-fill karein agar link pehle se database mein hai
        setGoogleReviewLink(parsedData.data.google_review_link || "");
      } else {
        // Agar link nahi milta to safe state defaults par rollback karein
        setSavedReview(null);
        setGoogleReviewLink("");
      }
      setLoadingReview(false);
    })
    .catch((err) => {
      console.error("Critical Runtime Error inside fetchGoogleReview logic:", err);
      setSavedReview(null);
      setGoogleReviewLink("");
      setLoadingReview(false);
    });
};
 const saveGoogleReview = () => {
  // 1. Validation: Kahin link khali to nahi hai?
  if (!googleReviewLink || googleReviewLink.trim() === "") {
    alert("Please Enter a valid Google Review Link ⚠️");
    return;
  }

  if (!merchantId) {
    alert("Merchant Session Expired. Please reload the application.");
    return;
  }

  // UI state feedback update (Optional: visual loader display ke liye)
  setLoadingReview(true);

  // 2. FormData Architecture: PHP APIs ke saath 100% compatibility ke liye
  const formdata = new FormData();
  formdata.append("merchant_id", String(merchantId));
  formdata.append("google_review_link", googleReviewLink.trim());

  // 3. Network Fetch Lifecycle
  fetch("https://countmyvisit.com/Apis/save_google_review.php", {
    method: "POST",
    body: formdata, // Native multi-part/form-data payload dispatch
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP network error! Status: ${res.status}`);
      }
      return res.text(); // Raw text read kar rahe hain taaki agar backend echo kare to crash na ho
    })
    .then((result) => {
      // Clean backend text prints if any (DATABASE CONNECTED filter logic)
      let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
      const parsedData = JSON.parse(cleanJsonString);

      if (parsedData.success) {
        alert("Google Review Link Saved Successfully! 🎉");
        // Fresh state sync parameters mapping pull karein
        fetchGoogleReview();
      } else {
        alert(parsedData.message || "Server validation rejected submission pipeline.");
        setLoadingReview(false);
      }
    })
    .catch((err) => {
      console.error("Critical Runtime Error during sync execution:", err);
      alert("Network failure or Server parsing mismatch. Please try again.");
      setLoadingReview(false);
    });
};

  const deleteGoogleReview = () => {
    if (!window.confirm("Delete Google Review Link?")) return;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({ merchant_id: merchantId });

    fetch("https://countmyvisit.com/Apis/delete_google_review.php", {
      method: "POST",
      headers: myHeaders,
      body: raw
    })
      .then(res => res.json())
      .then(result => {
        alert(result.message);
        if (result.success) {
          setSavedReview(null);
          setGoogleReviewLink("");
        }
      });
  };

  const fetchMerchantDetails = () => {
    if (!merchantId) return;
    const formdata = new FormData();
    formdata.append("user_id", merchantId);

    fetch(`https://countmyvisit.com/Apis/getmarchantdashdetails.php?user_id=${merchantId}`, {
      method: "POST",
      body: formdata
    })
      .then((response) => response.text())
      .then((result) => {
        try {
          let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
          const parsedData = JSON.parse(cleanJsonString);
          if (parsedData.success && parsedData.merchant) setMerchantInfo(parsedData.merchant);
        } catch (e) {
          console.error("Merchant info parse error:", e);
        }
      });
  };

  const fetchRules = () => {
    if (!merchantId) return;
    const formdata = new FormData();
    formdata.append("merchant_id", merchantId);

    fetch("https://countmyvisit.com/Apis/get_merchant_passes.php", {
      method: "POST",
      body: formdata
    })
      .then((res) => res.text())
      .then((result) => {
        let json = result.replace(/DATABASE CONNECTED/g, "").trim();
        const data = JSON.parse(json);
        if (data.success) {
          setSubscription({ active: true, ...data.subscription, loaded: true });
          setRules(data.rewards || []);
        } else {
          setRules([]);
        }
      })
      .catch(() => setRules([]));
  };

  const addRule = () => {
    if (!visitNumber) return alert("Enter Visit Count");
    if (!reward) return alert("Enter Reward Name");
    if (!merchantId) return alert("Merchant Login Expired");
    if (!minBillAmount) return alert("Enter Minimum Bill Amount");
    if (rewardType === "discount" && !discountValue) return alert("Enter Discount Value");
    if (rewardType === "voucher" && !voucherValue) return alert("Enter Voucher Value");

    const formdata = new FormData();
    formdata.append("merchant_id", merchantId);
    formdata.append("title", `Visit ${visitNumber} Times`);
    formdata.append("reward", reward);
    formdata.append("total_visits", visitNumber);
    formdata.append("min_bill_amount", minBillAmount);
    formdata.append("voucher_value", rewardType === "voucher" ? voucherValue : "0");
    formdata.append("discount_value", rewardType === "discount" ? discountValue : "0");
    formdata.append("discount_type", rewardType === "discount" ? discountType : "");
    formdata.append("reward_type", rewardType);

    const url = editingId
      ? `https://countmyvisit.com/Apis/edit_loyalty_pass.php?pass_id=${editingId}`
      : "https://countmyvisit.com/Apis/add_loyalty_pass.php";

    if (editingId) formdata.append("id", editingId);

    fetch(url, { method: "POST", body: formdata })
      .then(res => res.text())
      .then(result => {
        let cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
        const resObj = JSON.parse(cleanJsonString);
        if (resObj.success) {
          alert(editingId ? "Rule Updated Successfully 🎉" : "Rule Added Successfully 🚀");
          setEditingId(null);
          setVisitNumber("");
          setReward("");
          setDiscountValue("");
          setVoucherValue("");
          setMinBillAmount("");
          setRewardType("discount");
          setDiscountType("percentage");
          fetchRules();
        } else {
          alert(resObj.message || "Operation failed");
        }
      });
  };

  const handleEditClick = (item) => {
    setEditingId(item.id);
    setVisitNumber(item.visit_required || item.total_visits || "");
    setReward(item.reward || "");
    setRewardType(item.reward_type || "discount");
    setMinBillAmount(item.minimum_bill_amount || "");
    setDiscountType(item.discount_type || "percentage");
    setDiscountValue(item.discount_value || "");
    setVoucherValue(item.voucher_value || "");
    window.scrollTo({ top: 300, behavior: 'smooth' });
  };

  const deleteRule = (id) => {
    if (!window.confirm("Are you sure you want to delete this pass?")) return;
    const formdata = new FormData();
    formdata.append("id", String(id));

    fetch("https://countmyvisit.com/Apis/delete_loyalty_pass.php", { method: "POST", body: formdata })
      .then(() => {
        alert("Pass Deleted Successfully!");
        fetchRules();
      });
  };

 
 const handleLogout = () => {
  localStorage.removeItem("marchentdata");
  localStorage.removeItem("isLoggedIn");

  // { replace: true } se back button dabane par user wapas Dashboard par nahi aa payega
  navigate("/", { replace: true });
};
  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
        body { background: #f8fafc; color: #1e293b; }
        .merchant-page { min-height: 100vh; padding: 12px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); }
        .premium-nav { display: flex; flex-direction: column; gap: 16px; background: #ffffff; padding: 16px; border-radius: 16px; box-shadow: 0 4px 20px -2px rgba(15,23,42,0.05); margin-bottom: 20px; border: 1px solid rgba(255,255,255,0.8); }
        .nav-logo-side { display: flex; align-items: center; gap: 14px; width: 100%; justify-content: center; }
        .nav-brand { font-size: 18px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        .nav-actions { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; justify-content: center; width: 100%; }
        .nav-btn { padding: 10px 14px; font-size: 12px; font-weight: 600; border-radius: 10px; cursor: pointer; transition: all 0.2s ease; border: none; display: flex; align-items: center; gap: 6px; flex: 1 1 calc(50% - 8px); justify-content: center; min-width: 120px; }
        .btn-primary-nav { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 12px rgba(255,94,98,0.25); }
        .btn-secondary-nav { background: #f1f5f9; color: #475569; }
        .btn-danger-nav { background: #fee2e2; color: #ef4444; }
        .sub-status-bar { display: flex; flex-direction: column; gap: 12px; align-items: center; text-align: center; padding: 16px; border-radius: 14px; margin-bottom: 20px; font-weight: 600; font-size: 14px; }
        .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
        .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
        .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 12px; }
        .sub-renew-btn { width: 100%; max-width: 200px; background: #ef4444; color: white; border: none; padding: 10px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; }
        .top-header { background: #ffffff; padding: 16px; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,0,0,0.02); display: flex; flex-direction: column-reverse; gap: 16px; align-items: center; text-align: center; margin-bottom: 20px; border-left: 6px solid #ff8c42; }
        .merchant-title { font-size: 22px; font-weight: 800; color: #0f172a; text-transform: capitalize; }
        .merchant-logo { width: 48px; height: 48px; border-radius: 12px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 18px; }
        .main-grid { display: grid; grid-template-columns: 1fr; gap: 20px; align-items: start; }
        .card { background: white; border-radius: 16px; padding: 20px; box-shadow: 0 10px 25px rgba(15,23,42,0.03); border: 1px solid #e2e8f0; margin-bottom: 20px; }
        .input-group { margin-bottom: 14px; text-align: left; }
        .input-group label { display: block; margin-bottom: 6px; font-size: 11px; font-weight: 700; color: #475569; text-transform: uppercase; }
        .input-group input, .input-group select { width: 100%; height: 44px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 10px; padding: 0 12px; font-size: 14px; color: #334155; outline: none; }
        .save-btn { width: 100%; height: 46px; border: none; border-radius: 10px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 14px; font-weight: 600; cursor: pointer; }
        .table-scroll-container { max-height: 540px; overflow-x: auto; overflow-y: auto; border-radius: 12px; border: 1px solid #e2e8f0; background: #ffffff; width: 100%; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #f8fafc; color: #475569; padding: 12px 14px; font-size: 12px; font-weight: 700; border-bottom: 2px solid #e2e8f0; position: sticky; top: 0; z-index: 10; }
        td { padding: 12px 14px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 13px; }
        .badge { display: inline-block; padding: 4px 8px; border-radius: 10px; font-size: 10px; font-weight: 700; }
        .actions { display: flex; gap: 6px; }
        .edit-btn { border: none; padding: 6px 10px; border-radius: 6px; background: #fff7ed; color: #ea580c; font-weight: 600; cursor: pointer; }
        .delete-btn { border: none; padding: 6px 10px; border-radius: 6px; background: #fee2e2; color: #ef4444; font-weight: 600; cursor: pointer; }

        @media (min-width: 640px) {
          .merchant-page { padding: 20px; }
          .premium-nav { padding: 16px 24px; flex-direction: row; justify-content: space-between; }
          .nav-logo-side { width: auto; justify-content: flex-start; }
          .nav-actions { width: auto; justify-content: flex-end; }
          .nav-btn { flex: initial; }
          .sub-status-bar { flex-direction: row; justify-content: space-between; text-align: left; }
          .sub-renew-btn { width: auto; }
          .top-header { flex-direction: row; justify-content: space-between; text-align: left; padding: 20px 24px; }
        }
        @media (min-width: 1024px) {
          .main-grid { grid-template-columns: 400px 1fr; gap: 24px; }
        }
        * {
  -webkit-user-select: none;  /* Safari */
  -moz-user-select: none;     /* Firefox */
  -ms-user-select: none;      /* IE10+ */
  user-select: none;          /* Standard */
  -webkit-user-drag: none;    /* इमेजेस या एलिमेंट्स को ड्रैग करने से रोकने के लिए */
}
      `}</style>

      <div className="merchant-page">
        {/* Component 1: Top Navigation, Subscriptions & Header Details */}
        <DashboardNav 
          subscription={subscription}
          merchantInfo={merchantInfo}
          fetchRules={fetchRules}
          checkSubscription={checkSubscription}
          navigate={navigate}
          handleLogout={handleLogout}
        />

        <div className="main-grid">
          {/* Component 2: Rules Input Creation Forms */}
          <LoyaltyForm 
            editingId={editingId}
            subscription={subscription}
            visitNumber={visitNumber}
            setVisitNumber={setVisitNumber}
            reward={reward}
            setReward={setReward}
            rewardType={rewardType}
            setRewardType={setRewardType}
            minBillAmount={minBillAmount}
            setMinBillAmount={setMinBillAmount}
            discountType={discountType}
            setDiscountType={setDiscountType}
            discountValue={discountValue}
            setDiscountValue={setDiscountValue}
            voucherValue={voucherValue}
            setVoucherValue={setVoucherValue}
            addRule={addRule}
          />
 
          {/* Component 3 Section Part B: Live Campaign Infrastructure Data Grid */}
          {/* <div className="card">
            <h2>Active Campaign Infrastructure</h2>
            <p>Live campaigns operating on checkout logs counters. Internal container scrolls dynamically.</p>

            <div className="table-scroll-container">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Campaign ID</th>
                    <th>Target Metric</th>
                    <th>Benefits Array Details</th>
                    <th>State</th>
                    <th>Control Operations</th>
                  </tr>
                </thead>
                <tbody>
                  {rules.length > 0 ? (
                    rules.map((item, index) => (
                      <tr key={item.id || index}>
                        <td><strong>{index + 1}</strong></td>
                        <td>{item.title || `Visit Pass #${item.id}`}</td>
                        <td>
                          <span className="badge" style={{ background: "#f1f5f9", color: "#334155" }}>
                            🎯 {item.visit_required || item.total_visits} Visits
                          </span>
                        </td>
                        <td>
                          <div style={{ fontWeight: "700", color: "#0f172a" }}>{item.reward}</div>
                          <div style={{ fontSize: "11px", color: "#64748b", marginTop: "4px", lineHeight: "1.4" }}>
                            Type: <strong>{item.reward_type?.toUpperCase()}</strong><br />
                            Min Invoice Check: <strong>₹{item.minimum_bill_amount || 0}</strong>
                            {item.reward_type === "discount" && (
                              <>
                                <br />Value Metric: <strong>
                                  {item.discount_type === "percentage" ? `${item.discount_value}% Off` : `₹${item.discount_value} Deducted`}
                                </strong>
                              </>
                            )}
                            {item.reward_type === "voucher" && (
                              <>
                                <br />Voucher Yield: <strong>₹{item.voucher_value || 0}</strong>
                              </>
                            )}
                          </div>
                        </td>
                        <td>
                          <span className="badge" style={{ background: item.status === "active" ? "#dcfce7" : "#fee2e2", color: item.status === "active" ? "#15803d" : "#dc2626" }}>
                            {item.status || "Active"}
                          </span>
                        </td>
                        <td>
                          <div className="actions">
                            <button className="edit-btn" onClick={() => handleEditClick(item)}>✏️ Edit</button>
                            <button className="delete-btn" onClick={() => deleteRule(item.id)}>🗑️ Remove</button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center", padding: "60px 0", color: "#94a3b8", fontWeight: "500" }}>
                        📭 No active structural loyalty passes found in this query.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div> */}
          <div className="card" style={{ 
  background: "#ffffff", 
  borderRadius: "28px", 
  padding: "24px 20px", 
  border: "1px solid #e2e8f0", 
  boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.03)",
  textAlign: "left"
}}>
  <h2 style={{ fontSize: "20px", fontWeight: "850", color: "#0f172a", margin: "0 0 6px 0", letterSpacing: "-0.4px" }}>
  Your Visting Offers
  </h2>
  {/* <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 20px 0", lineHeight: "1.5" }}>
    Live campaigns operating on checkout logs counters. Scrollable vault container with desktop multi-column alignment.
  </p> */}

  {/* Dynamic Responsive Grid Wrapper with Internal Custom Scrolling */}
  <div style={{ 
    display: "grid",
    // responsive handling using auto-fit: computer screen par automatically 4 columns fit honge (min 260px each), mobile pr 1 column
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", 
    gap: "16px",
    maxHeight: "520px", // Is height ki wajah se 2 ya 3 cards ke baad scroll chalne lagega
    overflowY: "auto",
    paddingRight: "6px", // Smooth scrolling track space
    paddingBottom: "10px"
  }}>
    {rules.length > 0 ? (
      rules.map((item, index) => {
        const isVoucher = item.reward_type?.toLowerCase() === "voucher";
        const isActive = (item.status || "active").toLowerCase() === "active";
        
        return (
          <div 
            key={item.id || index}
            style={{
              background: "#ffffff",
              borderRadius: "24px",
              padding: "20px",
              border: "1px solid #e2e8f0",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 8px 20px -6px rgba(0, 0, 0, 0.02)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between", // content aur buttons ko clear adjust rakhne ke liye
              minHeight: "210px" // Uniform height configuration across the grid
            }}
          >
            {/* Left Accent Gradient Border Strip */}
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "6px",
              height: "100%",
              background: isVoucher 
                ? "linear-gradient(to bottom, #ec4899, #f43f5e)" 
                : "linear-gradient(to bottom, #3b82f6, #1d4ed8)"
            }} />

            {/* Core Card Details Container */}
            <div>
              {/* Header: Campaign Title & Target Metrics Badge */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "14px", gap: "8px" }}>
                <div style={{ flex: 1 }}>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Campaign #{index + 1}
                  </span>
                  <h4 style={{ fontSize: "16px", fontWeight: "800", color: "#0f172a", margin: "4px 0 0 0", letterSpacing: "-0.3px", lineHeight: "1.3" }}>
                    {item.title || `Visit Pass #${item.id}`}
                  </h4>
                </div>
                
                {/* Highlighted Target Counter Badge */}
                <span style={{ 
                  fontSize: "11px", 
                  fontWeight: "800", 
                  background: isVoucher ? "#fce7f3" : "#dbeafe", 
                  color: isVoucher ? "#db2777" : "#1d4ed8", 
                  padding: "5px 10px", 
                  borderRadius: "100px",
                  whiteSpace: "nowrap"
                }}>
                  🎯 {item.visit_required || item.total_visits || 0} V
                </span>
              </div>

              {/* Dynamic Reward Content Display */}
              <div style={{ marginBottom: "16px" }}>
                <div style={{ fontSize: "15px", fontWeight: "700", color: "#334155", marginBottom: "8px" }}>
                  {item.reward}
                </div>
                
                {/* Informative Grid/Capsule Tags */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  <span style={{ fontSize: "11px", fontWeight: "600", background: "#f1f5f9", color: "#475569", padding: "3px 8px", borderRadius: "6px" }}>
                    🎟️ {item.reward_type?.toUpperCase()}
                  </span>
                  
                  <span style={{ fontSize: "11px", fontWeight: "600", background: "#f8fafc", color: "#64748b", padding: "3px 8px", borderRadius: "6px", border: "1px dashed #cbd5e1" }}>
                    Min: <b>₹{item.minimum_bill_amount || 0}</b>
                  </span>

                  {item.reward_type === "discount" && (
                    <span style={{ fontSize: "11px", fontWeight: "700", background: "#f0fdf4", color: "#16a34a", padding: "3px 8px", borderRadius: "6px" }}>
                      ✨ {item.discount_type === "percentage" ? `${item.discount_value}% Off` : `₹${item.discount_value} Off`}
                    </span>
                  )}

                  {item.reward_type === "voucher" && (
                    <span style={{ fontSize: "11px", fontWeight: "700", background: "#faf5ff", color: "#9333ea", padding: "3px 8px", borderRadius: "6px" }}>
                      🎁 ₹{item.voucher_value || 0}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Footer Row: Status Tracking & Operations Controls */}
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <span style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "600" }}>System Status:</span>
                <span style={{ 
                  fontSize: "11px", 
                  fontWeight: "700", 
                  background: isActive ? "#dcfce7" : "#fee2e2", 
                  color: isActive ? "#15803d" : "#dc2626", 
                  padding: "3px 8px", 
                  borderRadius: "6px", 
                  textTransform: "uppercase"
                }}>
                  ● {item.status || "Active"}
                </span>
              </div>

              {/* Tactile Control Operations Footer */}
              <div style={{ 
                display: "grid", 
                gridTemplateColumns: "1fr 1fr", 
                gap: "8px", 
                borderTop: "1px solid #f1f5f9", 
                paddingTop: "10px" 
              }}>
                <button 
                  onClick={() => handleEditClick(item)}
                  style={{ 
                    height: "36px", 
                    border: "none", 
                    borderRadius: "10px", 
                    background: "#f1f5f9", 
                    color: "#1e293b", 
                    fontSize: "12px", 
                    fontWeight: "700", 
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px"
                  }}
                >
                  ✏️ Edit
                </button>
                <button 
                  onClick={() => deleteRule(item.id)}
                  style={{ 
                    height: "36px", 
                    border: "none", 
                    borderRadius: "10px", 
                    background: "#fef2f2", 
                    color: "#dc2626", 
                    fontSize: "12px", 
                    fontWeight: "700", 
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px"
                  }}
                >
                  🗑️ Remove
                </button>
              </div>
            </div>

          </div>
        );
      })
    ) : (
      /* Empty State Block */
      <div style={{ 
        gridColumn: "1 / -1", // Full-width error display on Grid
        textAlign: "center", 
        padding: "50px 20px", 
        color: "#94a3b8", 
        background: "#f8fafc", 
        borderRadius: "20px",
        border: "1px dashed #cbd5e1"
      }}>
        <div style={{ fontSize: "32px", marginBottom: "10px" }}>📭</div>
        <div style={{ fontSize: "14px", fontWeight: "600", color: "#64748b" }}>
          No active structural loyalty passes found in this query.
        </div>
      </div>
    )}
  </div>
</div>
        </div>
      

        {/* REPUTATION INTEGRATOR PLATFORM */}
        <div className="card">
          <h2>Google Review Link</h2>
          <p>Customers will be redirected here after redeeming rewards.</p>

          {loadingReview ? (
            <p>Loading...</p>
          ) : savedReview ? (
            <>
              <div className="input-group">
                <label>Saved Google Review Link</label>
                <input value={savedReview.google_review_link} readOnly />
              </div>
              <button className="delete-btn" onClick={deleteGoogleReview}>Delete Review Link</button>
            </>
          ) : (
            <>
              <div className="input-group">
                <label>Google Review Link</label>
                <input
                  type="text"
                  placeholder="https://g.page/r/xxxx/review"
                  value={googleReviewLink}
                  onChange={(e) => setGoogleReviewLink(e.target.value)}
                />
              </div>
              <button className="save-btn" onClick={saveGoogleReview}>Save Google Review Link</button>
            </>
          )}
        </div>
      </div>
    </>
  );
}